import { cn } from '@ui/lib/utils';
import { FC, SVGProps } from 'react';
export const HealthConditionIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17 6H15V4H17C17.2652 4 17.5196 3.89464 17.7071 3.70711C17.8946 3.51957 18 3.26522 18 3C18 2.73478 17.8946 2.48043 17.7071 2.29289C17.5196 2.10536 17.2652 2 17 2H9C7.67392 2 6.40215 2.52678 5.46447 3.46447C4.52678 4.40215 4 5.67392 4 7V21C4 21.2652 4.10536 21.5196 4.29289 21.7071C4.48043 21.8946 4.73478 22 5 22C5.26522 22 5.51957 21.8946 5.70711 21.7071C5.89464 21.5196 6 21.2652 6 21V7C6 6.20435 6.31607 5.44129 6.87868 4.87868C7.44129 4.31607 8.20435 4 9 4H13V6H11C10.2044 6 9.44129 6.31607 8.87868 6.87868C8.31607 7.44129 8 8.20435 8 9V13.93C7.99982 14.4249 8.12207 14.9122 8.35587 15.3484C8.58968 15.7846 8.92776 16.1562 9.34 16.43L11 17.54V18C11 18.5304 11.2107 19.0391 11.5858 19.4142C11.9609 19.7893 12.4696 20 13 20V21C13 21.2652 13.1054 21.5196 13.2929 21.7071C13.4804 21.8946 13.7348 22 14 22C14.2652 22 14.5196 21.8946 14.7071 21.7071C14.8946 21.5196 15 21.2652 15 21V20C15.5304 20 16.0391 19.7893 16.4142 19.4142C16.7893 19.0391 17 18.5304 17 18V17.54L18.66 16.43C19.0722 16.1562 19.4103 15.7846 19.6441 15.3484C19.8779 14.9122 20.0002 14.4249 20 13.93V9C20 8.20435 19.6839 7.44129 19.1213 6.87868C18.5587 6.31607 17.7956 6 17 6ZM16 11H18V12H17C16.7348 12 16.4804 12.1054 16.2929 12.2929C16.1054 12.4804 16 12.7348 16 13C16 13.2652 16.1054 13.5196 16.2929 13.7071C16.4804 13.8946 16.7348 14 17 14H18C17.9893 14.1518 17.9441 14.2992 17.8679 14.4309C17.7916 14.5626 17.6863 14.6752 17.56 14.76L15.46 16.17C15.3206 16.2594 15.2056 16.3821 15.1253 16.527C15.045 16.6718 15.0019 16.8344 15 17V18H13V17C12.9991 16.8353 12.9576 16.6733 12.8791 16.5285C12.8006 16.3838 12.6876 16.2606 12.55 16.17L10.45 14.76C10.3124 14.6694 10.1994 14.5462 10.1209 14.4015C10.0424 14.2567 10.0009 14.0947 10 13.93V9C10 8.73478 10.1054 8.48043 10.2929 8.29289C10.4804 8.10536 10.7348 8 11 8H17C17.2652 8 17.5196 8.10536 17.7071 8.29289C17.8946 8.48043 18 8.73478 18 9H16C15.7348 9 15.4804 9.10536 15.2929 9.29289C15.1054 9.48043 15 9.73478 15 10C15 10.2652 15.1054 10.5196 15.2929 10.7071C15.4804 10.8946 15.7348 11 16 11V11Z"
      fill="#262338"
    />
  </svg>
);

/* WarningIcon */
export const WarningIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 22"
    width={22}
    height={22}
    className={cn('w-5 h-5', props.className)}
    {...props}
  >
    <path
      fill="#D97706"
      d="M22.6,16.4l-8-14c-0.3-0.5-0.6-0.9-1.1-1.1C13,1,12.5,0.9,12,0.9c-0.5,0-1.1,0.1-1.5,0.4C10,1.6,9.6,2,9.4,2.4
      l-8,14c-0.3,0.5-0.4,1-0.4,1.5c0,0.5,0.1,1,0.4,1.5c0.3,0.5,0.6,0.8,1.1,1.1c0.5,0.3,1,0.4,1.5,0.4h16c0.5,0,1-0.1,1.5-0.4
      c0.5-0.3,0.8-0.6,1.1-1.1c0.3-0.5,0.4-1,0.4-1.5C23,17.3,22.9,16.8,22.6,16.4z"
    />
    <path
      fill="#FFFFFF"
      d="M12,15.1c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.1-0.3,0.3-0.4,0.5c-0.1,0.2-0.1,0.4-0.1,0.7c0,0.2,0.2,0.4,0.3,0.6
      c0.2,0.2,0.4,0.3,0.6,0.3c0.2,0,0.5,0,0.7-0.1c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.4,0.2-0.6c0-0.3-0.1-0.6-0.3-0.8
      C12.6,15.2,12.3,15.1,12,15.1z M12,5.9c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.3,0.8v4.6c0,0.3,0.1,0.6,0.3,0.8
      c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V7.1c0-0.3-0.1-0.6-0.3-0.8C12.6,6,12.3,5.9,12,5.9z"
    />
  </svg>
);

export const ScaleIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path d="M20.1819 20.4615H19.3048L18.1127 15.2492C18.9628 14.1093 19.466 12.7253 19.466 11.2308C19.466 9.10544 18.4523 7.20144 16.86 5.91385V3.53846H20.1818C20.6334 3.53846 21 3.19463 21 2.76923C21 2.34384 20.6334 2 20.1818 2H3.81824C3.36663 2 3.00007 2.34384 3.00007 2.76923C3.00007 3.19463 3.36663 3.53846 3.81824 3.53846H7.14005V5.91385C5.54783 7.2015 4.5341 9.10544 4.5341 11.2308C4.5341 12.7254 5.03727 14.1091 5.88732 15.2492L4.69524 20.4615H3.81818C3.36657 20.4615 3 20.8054 3 21.2308C3 21.6562 3.36657 22 3.81818 22H20.1818C20.6334 22 20.9999 21.6562 20.9999 21.2308C20.9999 20.8054 20.6334 20.4615 20.1818 20.4615H20.1819ZM8.77647 3.53846H15.2237V4.90921C14.246 4.46691 13.1553 4.21153 12.0001 4.21153C10.8449 4.21153 9.75414 4.46689 8.77647 4.90921V3.53846ZM12.0001 5.74995C15.2148 5.74995 17.8297 8.20841 17.8297 11.2308C17.8297 14.2531 15.2148 16.7116 12.0001 16.7116C8.78542 16.7116 6.17052 14.2531 6.17052 11.2308C6.17052 8.20841 8.78542 5.74995 12.0001 5.74995ZM6.3695 20.4615L7.2441 16.6369C8.53682 17.6438 10.1946 18.25 12.0002 18.25C13.8059 18.25 15.4636 17.6438 16.7564 16.6369L17.631 20.4615H6.3695Z" />
    <path d="M12.0001 12.6654C12.9026 12.6654 13.6365 11.9754 13.6365 11.1269C13.6365 10.99 13.6111 10.86 13.5751 10.7338L15.6296 8.80227C15.9495 8.50147 15.9495 8.01533 15.6296 7.71461C15.3096 7.41381 14.7926 7.41381 14.4727 7.71461L12.4182 9.64618C12.2841 9.61237 12.145 9.58849 12.0001 9.58849C11.0977 9.58849 10.3638 10.2785 10.3638 11.127C10.3638 11.9754 11.0977 12.6654 12.0001 12.6654L12.0001 12.6654Z" />
  </svg>
);

/* Dashboard Tabs Icons */

/* Appointments Icon */
export const AppointmentsIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="currentColor"
      d="M19 22H5a2 2 0 01-2-2V6a2 2 0 012-2h2V2h2v2h6V2h2v2h2a2 2 0 012 2v14a2 2 0 01-2 2zM5 10v10h14V10H5zm0-4v2h14V6H5zm12 12h-2v-2h2v2zm-4 0h-2v-2h2v2zm-4 0H7v-2h2v2zm8-4h-2v-2h2v2zm-4 0h-2v-2h2v2zm-4 0H7v-2h2v2z"
    ></path>
  </svg>
);

/* Courses Icon */
export const CoursesIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      d="M22.466 9.343l-1.048-.622-9.43-5.653h-.115a1.052 1.052 0 00-.2-.068h-.388a1.16 1.16 0 00-.209.068h-.115L1.531 8.72a1.091 1.091 0 00-.389.415 1.2 1.2 0 000 1.138c.094.173.228.316.39.414l2.608 1.56v5.36c0 .9.331 1.762.92 2.398.59.637 1.39.994 2.223.994h8.383c.833 0 1.633-.357 2.222-.994.59-.636.92-1.498.92-2.398v-5.36l2.096-1.266v3.234c0 .3.11.588.307.8.197.212.463.33.741.33.278 0 .544-.118.741-.33.197-.212.307-.5.307-.8v-3.89c0-.2-.05-.396-.144-.57a1.09 1.09 0 00-.39-.413zm-5.753 8.265c0 .3-.11.587-.306.8a1.01 1.01 0 01-.741.33H7.283a1.01 1.01 0 01-.74-.33 1.177 1.177 0 01-.307-.8v-4.104l4.725 2.826.157.068h.095a.973.973 0 00.262 0 .974.974 0 00.261 0h.095a.472.472 0 00.157-.068l4.725-2.826v4.104zm-5.239-3.55L4.204 9.693l7.272-4.364 7.271 4.364-7.271 4.365z"
    ></path>
  </svg>
);

/* Customers and Pets Icon */
export const CustomersAndPetsIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      d="M14.36 14.23a3.76 3.76 0 01-4.72 0 1.001 1.001 0 00-1.28 1.54 5.68 5.68 0 007.28 0 1.001 1.001 0 00-1.28-1.54zM12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16.001A8 8 0 0112 20z"
    ></path>
    <circle cx="9.5" cy="9.5" r="1.5" fill="#262338"></circle>
    <circle cx="14.5" cy="9.5" r="1.5" fill="#262338"></circle>
  </svg>
);

/* Dashboard Icon */
export const DashboardIcon: FC<SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g clipPath="url(#clip0_4691_4134)">
      <path
        fill="#262338"
        d="M12 2C6.483 2 2 6.483 2 12s4.483 10 10 10 10-4.483 10-10S17.517 2 12 2zM5.95 6.292l.808.808a.818.818 0 00.592.242.83.83 0 00.592-1.417L7.217 5.2a8.204 8.204 0 013.958-1.483v.791c0 .459.375.834.833.834a.836.836 0 00.834-.834v-.791A8.299 8.299 0 0117 5.35l-.583.583a.83.83 0 00.591 1.417.854.854 0 00.592-.242l.633-.633a8.34 8.34 0 012.075 4.692h-.791a.836.836 0 00-.834.833c0 .458.375.833.834.833h.791a8.39 8.39 0 01-1.341 3.759c-1.017-.792-3.092-1.959-6.425-2.075l1.416-3.9a.831.831 0 00-.5-1.067.831.831 0 00-1.066.5l-1.642 4.508c-2.9.25-4.742 1.3-5.683 2.034a8.257 8.257 0 01-1.342-3.759h.792A.836.836 0 005.35 12a.836.836 0 00-.833-.833h-.792a8.326 8.326 0 012.233-4.875H5.95zM12 20.333c-2.3 0-4.392-.941-5.9-2.45.842-.65 2.708-1.716 5.9-1.716s5.058 1.066 5.9 1.708a8.307 8.307 0 01-5.9 2.458z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_4691_4134">
        <path fill="#fff" d="M0 0H20V20H0z" transform="translate(2 2)"></path>
      </clipPath>
    </defs>
  </svg>
);

/* Invoices Icon */
export const InvoicesIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#fff"
      d="M3 3.5v16L5 21l15.5-.5-.5-7h-3l-1-10-3 2L12 4H9L6.5 5 3 3.5z"
    ></path>
    <path
      fill="#262338"
      d="M13 16H7a1 1 0 100 2h6a1 1 0 000-2zm-4-6h2a1 1 0 000-2H9a1 1 0 000 2zm12 2h-3V3a1 1 0 00-1.5-.87l-3 1.72-3-1.72a1 1 0 00-1 0l-3 1.72-3-1.72A1 1 0 002 3v16a3 3 0 003 3h14a3 3 0 003-3v-6a1 1 0 00-1-1zM5 20a1 1 0 01-1-1V4.73l2 1.14a1.08 1.08 0 001 0l3-1.72 3 1.72a1.08 1.08 0 001 0l2-1.14V19a3 3 0 00.18 1H5zm15-1a1 1 0 11-2 0v-5h2v5zm-7-7H7a1 1 0 100 2h6a1 1 0 000-2z"
    ></path>
  </svg>
);

/* Services Icon */
export const ServicesIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      d="M5.5 20.5a1 1 0 01-1-1v-15a1 1 0 011-1h6.38a1 1 0 01.9.55l.61 1.228a.4.4 0 00.358.222H18.5a1 1 0 011 1v8a1 1 0 01-1 1h-5.39a1 1 0 01-.89-.55l-.61-1.228a.4.4 0 00-.358-.222H6.9a.4.4 0 00-.4.4v5.6a1 1 0 01-1 1zm1.4-15a.4.4 0 00-.4.4v5.2c0 .221.18.4.4.4h5.353a.4.4 0 01.358.221l.778 1.558a.4.4 0 00.358.221H17.1a.4.4 0 00.4-.4V7.9a.4.4 0 00-.4-.4h-4.353a.4.4 0 01-.358-.221l-.778-1.558a.4.4 0 00-.358-.221H6.9z"
    ></path>
  </svg>
);

/* Team Members Icon */
export const TeamMembersIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      d="M12.3 12.22A4.92 4.92 0 0014 8.5a5 5 0 00-10 0 4.92 4.92 0 001.7 3.72A8 8 0 001 19.5a1 1 0 102 0 6 6 0 1112 0 1 1 0 002 0 8 8 0 00-4.7-7.28zM9 11.5a3 3 0 110-6 3 3 0 010 6zm9.74.32A5 5 0 0015 3.5a1 1 0 100 2 3 3 0 013 3 3 3 0 01-1.5 2.59 1 1 0 00-.05 1.7l.39.26.13.07a7 7 0 014 6.38 1 1 0 002 0 9 9 0 00-4.23-7.68z"
    ></path>
  </svg>
);

/* Tutorials Icon */
export const TutorialsIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      d="M21.17 2.06A13.099 13.099 0 0019 1.87a12.94 12.94 0 00-7 2.05 12.94 12.94 0 00-7-2 13.1 13.1 0 00-2.17.19 1 1 0 00-.83 1v12a1 1 0 001.17 1 10.9 10.9 0 018.25 1.91l.12.07h.11a.91.91 0 00.7 0h.11l.12-.07A10.9 10.9 0 0120.83 16 1.001 1.001 0 0022 15V3a1 1 0 00-.83-.94zM11 15.35a12.87 12.87 0 00-6-1.48H4v-10c.333-.02.667-.02 1 0a10.86 10.86 0 016 1.8v9.68zm9-1.44h-1a12.87 12.87 0 00-6 1.48V5.67a10.86 10.86 0 016-1.8c.333-.02.667-.02 1 0v10.04zm1.17 4.15a13.109 13.109 0 00-2.17-.19 12.94 12.94 0 00-7 2.05 12.94 12.94 0 00-7-2.05 13.11 13.11 0 00-2.17.19A1.002 1.002 0 002 19.21a1 1 0 001.17.79 10.903 10.903 0 018.25 1.91 1 1 0 001.16 0A10.904 10.904 0 0120.83 20a1 1 0 001.17-.79 1 1 0 00-.83-1.15z"
    ></path>
  </svg>
);

/* PawIcon Icon */
export const PawIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g clipPath="url(#clip0)">
      <path
        fill="currentColor"
        d="M21.833 11.475a3.88 3.88 0 00-.333-3.094c-.917-1.602-2.889-2.458-4.778-2.016l-.389.083v-.36C16.333 3.823 14.417 2 12.028 2h-.056c-2.36 0-4.305 1.823-4.305 4.088v.36l-.39-.083C5.39 5.95 3.445 6.779 2.5 8.38a3.794 3.794 0 00-.333 3.094c.333 1.05 1.055 1.906 2.083 2.431l.389.193-.389.332a1.522 1.522 0 01-.25.193 4.23 4.23 0 00-1.333 3.094c0 2.348 2.027 4.282 4.5 4.282h.416a4.86 4.86 0 002.056-.47l1.917-.911a1.12 1.12 0 01.416-.083c.14 0 .278.027.417.083l1.917.911c.639.304 1.333.47 2.055.47h.417c2.472 0 4.5-1.906 4.5-4.282a4.23 4.23 0 00-1.333-3.094c-.084-.083-.14-.138-.25-.193l-.39-.332.39-.193c1.055-.525 1.805-1.381 2.138-2.43zm-9.86-7.652h.055c1.444 0 2.61 1.105 2.61 2.486 0 1.382-1.166 2.487-2.61 2.487h-.056c-1.444 0-2.61-1.105-2.61-2.487 0-1.38 1.166-2.486 2.61-2.486zm-8.39 6.464c0-1.353 1.167-2.486 2.611-2.486 1.445 0 2.612 1.105 2.612 2.486 0 1.381-1.167 2.486-2.612 2.486-1.444 0-2.61-1.104-2.61-2.486zm16.056 7.348v.166c-.056 1.437-1.306 2.597-2.833 2.597h-.445a3.31 3.31 0 01-1.278-.276l-1.916-.912A2.857 2.857 0 0012 18.96c-.417 0-.806.083-1.167.249l-1.916.912a2.875 2.875 0 01-1.278.276h-.445c-1.527 0-2.777-1.16-2.833-2.597v-.166c.028-.69.306-1.38.833-1.85a6.257 6.257 0 012.223-1.326 4.584 4.584 0 002.889-2.873c.222-.719.889-1.188 1.666-1.216h.056c.778.028 1.472.525 1.666 1.216.417 1.326 1.5 2.403 2.89 2.873a6.257 6.257 0 012.222 1.325c.5.498.805 1.16.833 1.851zm-1.833-4.862c-1.445 0-2.612-1.104-2.612-2.486 0-1.38 1.167-2.486 2.612-2.486 1.444 0 2.61 1.105 2.61 2.486 0 1.381-1.194 2.486-2.61 2.486z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0">
        <path fill="#fff" d="M0 0H20V20H0z" transform="translate(2 2)"></path>
      </clipPath>
    </defs>
  </svg>
);

/* Smile Icon */
export const SmileIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g clipPath="url(#clip0)">
      <path
        fill="currentColor"
        d="M14.36 14.23a3.76 3.76 0 01-4.72 0 1.001 1.001 0 00-1.28 1.54 5.68 5.68 0 007.28 0 1.001 1.001 0 00-1.28-1.54zM12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16.001A8 8 0 0112 20z"
      ></path>
      <circle cx="9.5" cy="9.5" r="1.5" fill="currentColor"></circle>
      <circle cx="14.5" cy="9.5" r="1.5" fill="currentColor"></circle>
    </g>
    <defs>
      <clipPath id="clip0">
        <path fill="#fff" d="M0 0H20V20H0z" transform="translate(2 2)"></path>
      </clipPath>
    </defs>
  </svg>
);

/* Emergency Icon */
export const EmergencyIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="currentColor"
      d="M19 2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3m1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zM17 9h-2V7a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v2H7a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h2v2a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-2h2a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1m-1 4h-2a1 1 0 0 0-1 1v2h-2v-2a1 1 0 0 0-1-1H8v-2h2a1 1 0 0 0 1-1V8h2v2a1 1 0 0 0 1 1h2z"
    />
  </svg>
);

/* Waving Icon */
export const WavingIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g fill="currentColor" clipPath="url(#a)">
      <path d="m5.242 7.438-.025-.047c-.21-.373-.425-.743-.631-1.118a2.38 2.38 0 0 1-.28-1.56c.163-.998.72-1.678 1.66-2.01.624-.22 1.242-.162 1.838.127q.276.136.508.34l.049.041c.076-.102.144-.204.223-.298.369-.443.834-.729 1.395-.835.78-.149 1.478.045 2.085.569.218.188.389.416.531.669q.533.942 1.068 1.882l.392.69.03.05q.02-.023.034-.042c.43-.584 1-.923 1.71-1.009.51-.061.994.04 1.446.29.412.23.729.557.963.97.591 1.044 1.188 2.085 1.775 3.131q.549.983.795 2.087a7.9 7.9 0 0 1 .167 2.371 8 8 0 0 1-.22 1.318 7.8 7.8 0 0 1-.649 1.708 7.74 7.74 0 0 1-2.428 2.781 7.58 7.58 0 0 1-7.702.616 7.7 7.7 0 0 1-2.044-1.456 8.3 8.3 0 0 1-1.377-1.84c-.65-1.157-1.309-2.31-1.964-3.465l-1.255-2.212A2.5 2.5 0 0 1 3 9.993a2.47 2.47 0 0 1 .686-1.798c.346-.37.768-.6 1.257-.708.096-.021.195-.032.298-.049m9.287 2.14-.007-.016-1.19-2.098-1.362-2.398c-.206-.363-.405-.73-.619-1.086-.23-.382-.573-.559-1.013-.516-.607.058-1.032.65-.915 1.26.034.175.119.325.205.476l2.175 3.832a.76.76 0 0 1 .102.448.704.704 0 0 1-.795.636.72.72 0 0 1-.53-.386q-.751-1.327-1.504-2.653L7.642 4.552c-.19-.334-.478-.523-.856-.547a1 1 0 0 0-.88.401 1.07 1.07 0 0 0-.104 1.158q.237.429.482.856l2.278 4.014c.199.351.402.7.595 1.055a.705.705 0 0 1-.2.884.694.694 0 0 1-.894-.037c-.096-.09-.156-.206-.22-.318L6.36 9.403c-.344-.605-1.134-.73-1.627-.26-.365.35-.439.88-.18 1.337q.708 1.254 1.42 2.504.926 1.628 1.848 3.257c.386.684.87 1.283 1.466 1.787a6.23 6.23 0 0 0 3.608 1.465q.543.035 1.083-.025a6.212 6.212 0 0 0 3.912-1.98 6.3 6.3 0 0 0 1.307-2.138c.296-.81.43-1.646.393-2.51a6.6 6.6 0 0 0-.141-1.112 6.6 6.6 0 0 0-.716-1.86l-1.72-3.028a1.041 1.041 0 0 0-1.87.091c-.142.34-.116.67.064.988q.431.759.861 1.519.137.241.073.514a.74.74 0 0 1-.366.478q-.734.447-1.098 1.235-.314.679-.254 1.43.048.627.354 1.176a.72.72 0 0 1 .085.535.68.68 0 0 1-.514.531.64.64 0 0 1-.686-.218 1.8 1.8 0 0 1-.217-.366 4.25 4.25 0 0 1-.43-1.958 4.3 4.3 0 0 1 1.27-2.987q.118-.115.244-.23M16.2 2.003a5.1 5.1 0 0 1 2.292.582 5.2 5.2 0 0 1 2.166 2.11.71.71 0 0 1-.248.928.69.69 0 0 1-.92-.162c-.077-.103-.137-.22-.21-.327a3.84 3.84 0 0 0-1.557-1.346 3.6 3.6 0 0 0-1.238-.344q-.215-.018-.43-.028a.71.71 0 0 1-.646-.622.71.71 0 0 1 .595-.79c.064-.008.13-.001.196-.001M7.83 22a.7.7 0 0 1-.418-.126 10.5 10.5 0 0 1-1.764-1.569 10.7 10.7 0 0 1-1.325-1.841.72.72 0 0 1 .304-1.025.695.695 0 0 1 .877.256c.167.266.326.538.504.796a8.9 8.9 0 0 0 1.851 1.95c.13.102.27.193.396.3a.68.68 0 0 1 .235.714.68.68 0 0 1-.553.532c-.041.009-.085.01-.108.013" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M3 2h18v20H3z" />
      </clipPath>
    </defs>
  </svg>
);

/* Microchip Icon */
export const MicrochipIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="currentColor"
      d="M17 3.5H7A3.5 3.5 0 0 0 3.5 7v10A3.5 3.5 0 0 0 7 20.5h10a3.5 3.5 0 0 0 3.5-3.5V7A3.5 3.5 0 0 0 17 3.5m-6.5 2h3v3h-3zm-2 13H7A1.5 1.5 0 0 1 5.5 17v-1.5h3zm5 0h-3v-3h3zm5-1.5a1.5 1.5 0 0 1-1.5 1.5h-1.5v-3h3zm0-3.5h-13V7A1.5 1.5 0 0 1 7 5.5h1.5v4a1 1 0 0 0 1 1h9zm0-5h-3v-3H17A1.5 1.5 0 0 1 18.5 7z"
    />
  </svg>
);

/* Success Icon */
export const SuccessIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <circle cx="12" cy="12" r="12" fill="#279559"></circle>
    <path
      fill="#fff"
      d="M16.46 7.415l-6.385 6.142-2.456-2.356a1.484 1.484 0 00-.482-.357 1.54 1.54 0 00-1.701.276c-.145.139-.259.305-.333.489a1.377 1.377 0 00.046 1.143c.089.177.215.335.371.463l3.498 3.37c.14.133.304.238.486.309a1.543 1.543 0 001.613-.308l7.443-7.142c.14-.133.25-.291.326-.465a1.378 1.378 0 000-1.099 1.426 1.426 0 00-.326-.465A1.521 1.521 0 0017.51 7c-.393 0-.77.15-1.05.415z"
    ></path>
  </svg>
);

/* Group Icon */
export const GroupHexagonIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      d="M2.51 19.27 7 21.83a1 1 0 0 0 1 0l4-2.28 4 2.28a1 1 0 0 0 1 0l4.49-2.56a1 1 0 0 0 .51-.87v-5.12a1 1 0 0 0-.51-.87l-4-2.27V5.6a1 1 0 0 0-.51-.87l-4.5-2.56a1 1 0 0 0-1 0L7 4.73a1 1 0 0 0-.51.87v4.54l-4 2.27a1 1 0 0 0-.51.87v5.12a1 1 0 0 0 .53.87M20 13.86v4l-3.5 2-3.5-2v-4l3.5-2zM8.5 6.18l3.5-2 3.5 2v4l-3.5 2-3.5-2zM4 13.86l3.5-2 3.5 2v4l-3.5 2-3.5-2z"
    />
  </svg>
);

/* CriticalIcon */
export const CriticalIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 22"
    width={22}
    height={22}
    className={cn('w-5 h-5', props.className)}
    {...props}
  >
    <path
      fill="#DC2626"
      d="M22.6,16.4l-8-14c-0.3-0.5-0.6-0.9-1.1-1.1C13,1,12.5,0.9,12,0.9c-0.5,0-1.1,0.1-1.5,0.4C10,1.6,9.6,2,9.4,2.4
      l-8,14c-0.3,0.5-0.4,1-0.4,1.5c0,0.5,0.1,1,0.4,1.5c0.3,0.5,0.6,0.8,1.1,1.1c0.5,0.3,1,0.4,1.5,0.4h16c0.5,0,1-0.1,1.5-0.4
      c0.5-0.3,0.8-0.6,1.1-1.1c0.3-0.5,0.4-1,0.4-1.5C23,17.3,22.9,16.8,22.6,16.4z"
    />
    <path
      fill="#FFFFFF"
      d="M12,15.1c-0.2,0-0.4,0.1-0.6,0.2c-0.2,0.1-0.3,0.3-0.4,0.5c-0.1,0.2-0.1,0.4-0.1,0.7c0,0.2,0.2,0.4,0.3,0.6
      c0.2,0.2,0.4,0.3,0.6,0.3c0.2,0,0.5,0,0.7-0.1c0.2-0.1,0.4-0.2,0.5-0.4c0.1-0.2,0.2-0.4,0.2-0.6c0-0.3-0.1-0.6-0.3-0.8
      C12.6,15.2,12.3,15.1,12,15.1z M12,5.9c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.3,0.8v4.6c0,0.3,0.1,0.6,0.3,0.8
      c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8V7.1c0-0.3-0.1-0.6-0.3-0.8C12.6,6,12.3,5.9,12,5.9z"
    />
  </svg>
);

/* DeclineFilled Icon */
export const DeclineFilledIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g clipPath="url(#clip0_2927_9102)">
      <path
        fill="#fff"
        d="M16.44 7.56a1.16 1.16 0 00-1.68 0L12 10.32 9.24 7.56a1.16 1.16 0 00-1.68 0c-.48.48-.48 1.2 0 1.68L10.32 12l-2.76 2.76c-.48.48-.48 1.2 0 1.68s1.2.48 1.68 0L12 13.68l2.76 2.76c.48.48 1.2.48 1.68 0s.48-1.2 0-1.68L13.68 12l2.76-2.76c.48-.48.48-1.2 0-1.68z"
      ></path>
      <path
        fill="#C00"
        d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm4.44 14.76c.48.48.48 1.2 0 1.68s-1.2.48-1.68 0L12 13.68l-2.76 2.76c-.48.48-1.2.48-1.68 0a1.16 1.16 0 010-1.68L10.32 12 7.56 9.24a1.16 1.16 0 010-1.68c.48-.48 1.2-.48 1.68 0L12 10.32l2.76-2.76c.48-.48 1.2-.48 1.68 0s.48 1.2 0 1.68L13.68 12l2.76 2.76z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_2927_9102">
        <path fill="#fff" d="M0 0H24V24H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

/* LightningIcon Icon */
export const LightningIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z"
      clipRule="evenodd"
    ></path>
  </svg>
);

/* InitialIcon */
export const InitialIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#F0A542"
      d="M11 3.775a1.2 1.2 0 0 1 2.282 0l1.284 3.95a1.2 1.2 0 0 0 1.14.83h4.154c1.163 0 1.646 1.487.706 2.172l-3.36 2.44a1.2 1.2 0 0 0-.436 1.342l1.284 3.95c.36 1.105-.907 2.025-1.848 1.342l-3.36-2.44a1.2 1.2 0 0 0-1.41 0l-3.36 2.44c-.94.683-2.207-.237-1.848-1.343l1.284-3.95a1.2 1.2 0 0 0-.436-1.341l-3.36-2.44c-.94-.685-.456-2.172.706-2.172h4.154a1.2 1.2 0 0 0 1.14-.83l1.285-3.95z"
    />
  </svg>
);

/* VideoCallIcon */
export const VideoCallIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#D92B55"
      d="M4.5 4.5a3 3 0 00-3 3v9a3 3 0 003 3h8.25a3 3 0 003-3v-9a3 3 0 00-3-3H4.5zM19.94 18.75l-2.69-2.69V7.94l2.69-2.69c.944-.945 2.56-.276 2.56 1.06v11.38c0 1.336-1.616 2.005-2.56 1.06z"
    ></path>
  </svg>
);

/* AddonsIcon */
export const AddonsIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#FFFFFF"
      d="M11.8,17c1,0,2-1,2-2v-1.4h1.1h0.2c1,0,2.1-0.7,2.1-1.6s-1-2-2.1-2h-0.2h-1.1V10
        c0-1-1-2-2-2s-2,1-2,2v1.2H10H9.8c-1,0-2.1,1-2.1,2s1,2,2.1,2h0.2H10v1.4C10,16,10.8,17,11.8,17z"
    />
    <path
      fill="#E14AA4"
      d="M21.6,11.1l-2.3-2.3v-3c0-0.6-0.5-1.2-1.2-1.2H15l-2.2-2.2c-0.5-0.5-1.2-0.5-1.6,0L9,4.6H5.8
        c-0.6,0-1.2,0.5-1.2,1.2V9l-2.3,2.3c-0.5,0.5-0.5,1.2,0,1.6l2.3,2.3v3.1c0,0.6,0.5,1.2,1.2,1.2h3.1l2.2,2.2c0.5,0.5,1.2,0.5,1.6,0
        l2.2-2.2h3.2c0.6,0,1.2-0.5,1.2-1.2V15l2.3-2.3C22,12.3,22,11.6,21.6,11.1z M14.8,13.5h-0.2h-1v1.3c0,0.9-0.9,1.8-1.8,1.8
        S10,15.9,10,15v-1.3H9.1H8.9c-0.9,0-1.8-0.9-1.8-1.8s0.9-1.8,1.8-1.8h0.2h1V8.9c0-0.8,0.9-1.6,1.8-1.6c0.9,0,1.8,0.9,1.8,1.8v1.1h1
        h0.2c0.9,0,1.8,0.9,1.8,1.8C16.7,12.9,15.8,13.5,14.8,13.5z"
    />
  </svg>
);

/* HeartIcon */
export const HeartIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#E14AA4"
      d="M2 8.4A5.4 5.4 0 017.5 3 5.991 5.991 0 0112 5a5.991 5.991 0 014.5-2A5.4 5.4 0 0122 8.4c0 5.356-6.379 9.4-10 12.6C8.387 17.773 2 13.76 2 8.4z"
    ></path>
  </svg>
);

/* CameraIcon */
export const CameraIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width={20}
    height={20}
    className={cn('w-5 h-5', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      fillRule="evenodd"
      d="M1 8a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 018.07 3h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0016.07 6H17a2 2 0 012 2v7a2 2 0 01-2 2H3a2 2 0 01-2-2V8zm13.5 3a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM10 14a3 3 0 100-6 3 3 0 000 6z"
      clipRule="evenodd"
    ></path>
  </svg>
);

/* Recurring Icon */
export const RecurringIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M20.453 12.893A8.5 8.5 0 014.638 16.25l-.25-.433m-.842-4.71A8.5 8.5 0 0119.361 7.75l.25.433M3.493 18.066l.732-2.732 2.732.732m10.085-8.132l2.732.732.732-2.732"
    />
  </svg>
);

/* RecurringPrepaid Icon */
export const RecurringPrepaidIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#5D5FEF"
      d="M21.825 16.356H16.39a1.2 1.2 0 100 2.4h2.88a9.6 9.6 0 01-16.536-6.612 1.2 1.2 0 10-2.4 0A12 12 0 0020.59 20.82v2.124a1.2 1.2 0 102.4 0v-5.4a1.2 1.2 0 00-1.164-1.188zM12.333.144a12 12 0 00-8.256 3.324V1.344a1.2 1.2 0 10-2.4 0v5.4a1.2 1.2 0 001.2 1.2h5.4a1.2 1.2 0 100-2.4h-2.88a9.6 9.6 0 0116.536 6.6 1.2 1.2 0 102.4 0 12 12 0 00-12-12z"
    />
  </svg>
);

/* Calendar Icons */

/* Customise Icon */
export const CustomiseIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      d="M15.82 20H21a1 1 0 000-2h-5.18a3 3 0 00-5.64 0H3a1 1 0 100 2h7.18a3 3 0 005.64 0zM12 19a1 1 0 112 0 1 1 0 01-2 0zm-2.18-6H21a1 1 0 000-2H9.82a3 3 0 00-5.64 0H3a1 1 0 100 2h1.18a3 3 0 005.64 0zM6 12a1 1 0 112 0 1 1 0 01-2 0zm11.82-6H21a1 1 0 100-2h-3.18a3 3 0 00-5.64 0H3a1 1 0 000 2h9.18a3 3 0 005.64 0zM14 5a1 1 0 112 0 1 1 0 01-2 0z"
    />
  </svg>
);

/* Agenda Icon */
export const AgendaIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      fillRule="evenodd"
      d="M5.817 6.152a1.462 1.462 0 11-2.924 0 1.462 1.462 0 012.924 0zm3.217-1.17a1.17 1.17 0 100 2.34h11.697a1.17 1.17 0 000-2.34H9.034zm0 5.848a1.17 1.17 0 000 2.34h11.697a1.17 1.17 0 000-2.34H9.034zm0 5.849a1.17 1.17 0 100 2.339h11.697a1.17 1.17 0 100-2.34H9.034zm-4.679-3.217a1.462 1.462 0 100-2.924 1.462 1.462 0 000 2.924zm0 5.848a1.462 1.462 0 100-2.924 1.462 1.462 0 000 2.924z"
      clipRule="evenodd"
    />
  </svg>
);

/* Today Icon */
export const TodayIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g fill="#262338">
      <path d="M19 4h-1.6c-.22 0-.4-.18-.4-.4V2.4c0-.22-.18-.4-.4-.4h-1.2c-.22 0-.4.18-.4.4v1.2c0 .22-.18.4-.4.4H9.4c-.22 0-.4-.18-.4-.4V2.4c0-.22-.18-.4-.4-.4H7.4c-.22 0-.4.18-.4.4v1.2c0 .22-.18.4-.4.4H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15.6c0 .22-.18.4-.4.4H5.4c-.22 0-.4-.18-.4-.4v-9.2c0-.22.18-.4.4-.4h13.2c.22 0 .4.18.4.4v9.2zm0-12c0 .22-.18.4-.4.4H5.4c-.22 0-.4-.18-.4-.4V6.4c0-.22.18-.4.4-.4h13.2c.22 0 .4.18.4.4v1.2z"></path>
      <path d="M12.95 13.27h-1.9a.56.56 0 00-.56.56v1.9c0 .31.25.56.56.56h1.9c.31 0 .56-.25.56-.56v-1.9a.56.56 0 00-.56-.56z"></path>
    </g>
  </svg>
);

/* Month Icon */
export const MonthIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      d="M21 2H3a1 1 0 00-1 1v18a1 1 0 001 1h18a1 1 0 001-1V3a1 1 0 00-1-1zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z"
    />
  </svg>
);

/* Week Icon */
export const WeekIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      d="M21 2H3a1 1 0 00-1 1v18a1 1 0 001 1h18a1 1 0 001-1V3a1 1 0 00-1-1zM8 20H4V4h4v16zm6 0h-4V4h4v16zm6 0h-4V4h4v16z"
    />
  </svg>
);

/* Day Icon */
export const DayIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g fill="#262338" clipPath="url(#clip0_4780_4176)">
      <path d="M20.992 2H3.03a1 1 0 000 2.003h17.962a1 1 0 000-2.003zM20.992 19.997H3.03a1 1 0 000 2.003h17.962a1 1 0 000-2.003zM18.341 17.99H5.66C3.64 17.99 2 16.33 2 14.287V9.68c0-2.043 1.641-3.705 3.659-3.705H18.34C20.36 5.976 22 7.638 22 9.68v4.605c0 2.043-1.641 3.705-3.659 3.705zM5.66 7.98c-.927 0-1.68.763-1.68 1.7v4.605c0 .939.753 1.702 1.68 1.702H18.34c.927 0 1.68-.764 1.68-1.702V9.681c0-.938-.754-1.701-1.68-1.701H5.66z"></path>
    </g>
    <defs>
      <clipPath id="clip0_4780_4176">
        <path fill="#fff" d="M0 0H20V20H0z" transform="translate(2 2)"></path>
      </clipPath>
    </defs>
  </svg>
);

/* Workflow Icon */
export const WorkflowIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      d="M20.34 9.32l-14-7a3 3 0 00-4.08 3.9l2.4 5.37a1.06 1.06 0 010 .82l-2.4 5.37A3 3 0 005 22a3.14 3.14 0 001.35-.32l14-7a3 3 0 000-5.36h-.01zm-.89 3.57l-14 7a1 1 0 01-1.35-1.3l2.39-5.37a2 2 0 00.08-.22h6.89a1 1 0 000-2H6.57a2 2 0 00-.08-.22L4.1 5.41a1 1 0 011.35-1.3l14 7a1 1 0 010 1.78z"
    />
  </svg>
);

/* Refresh Icon */
export const RefreshIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      d="M19.91 15.51h-4.53a1 1 0 000 2h2.4A8 8 0 014 12a1 1 0 10-2 0 10 10 0 0016.88 7.23V21a1 1 0 002 0v-4.5a1 1 0 00-.97-.99zM12 2a10 10 0 00-6.88 2.77V3a1 1 0 00-2 0v4.5a1 1 0 001 1h4.5a1 1 0 000-2h-2.4A8 8 0 0120 12a1 1 0 002 0A10 10 0 0012 2z"
    />
  </svg>
);

/* Reset Icon */
export const ResetIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g fill="#262338" clipPath="url(#clip0_4885_4154)">
      <path d="M17.3 3.747c-3.967-2.585-8.769-2.282-12.238.767V3.02a1.016 1.016 0 00-2.035 0v3.988c0 .555.458 1.01 1.018 1.01h4.008c.56 0 1.017-.455 1.017-1.01 0-.556-.458-1.01-1.017-1.01H6.446c3.347-2.908 7.334-2.12 9.745-.565 2.411 1.565 4.74 4.886 3.378 9.106-1.313 4.028-4.965 5.452-7.752 5.452h-.112c-2.798-.04-6.5-1.555-7.711-5.684-.153-.535-.722-.838-1.262-.687a1.01 1.01 0 00-.691 1.252c1.251 4.27 5.035 7.067 9.633 7.138h.163c4.527 0 8.312-2.675 9.665-6.855 1.414-4.361-.234-8.834-4.192-11.408h-.01z"></path>
      <path d="M11.837 15.151c1.712 0 3.1-1.377 3.1-3.075 0-1.699-1.388-3.076-3.1-3.076-1.711 0-3.099 1.377-3.099 3.076 0 1.698 1.388 3.075 3.1 3.075z"></path>
    </g>
    <defs>
      <clipPath id="clip0_4885_4154">
        <path fill="#fff" d="M0 0H20V20H0z" transform="translate(2 2)"></path>
      </clipPath>
    </defs>
  </svg>
);

/* Timeline Icon */
export const TimelineIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      fillRule="evenodd"
      d="M6 5a1 1 0 100 2 1 1 0 000-2zM3 6a3 3 0 015.83-1h6.34a3.001 3.001 0 111.537 3.708l-8 7.999c.046.095.087.193.122.293h6.342a3.001 3.001 0 110 2H8.829a3.001 3.001 0 11-1.536-3.708l8-7.999A2.959 2.959 0 0115.17 7H8.829A3.001 3.001 0 013 6zm15-1a1 1 0 100 2 1 1 0 000-2zM5 18a1 1 0 112 0 1 1 0 01-2 0zm13-1a1 1 0 100 2 1 1 0 000-2z"
      clipRule="evenodd"
    />
  </svg>
);

/* MultiDay Icon */
export const MultiDayIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#262338"
        fillRule="evenodd"
        d="M21.595 9.76a3.46 3.46 0 0 0-2.07-1.18c-.81-.14-1.64.01-2.34.43s-1.24 1.06-1.52 1.83h-7.34c-.27-.76-.81-1.42-1.52-1.83-.7-.42-1.53-.57-2.34-.43s-1.54.56-2.07 1.19a3.5 3.5 0 0 0-.81 2.24c0 .82.29 1.61.82 2.24a3.46 3.46 0 0 0 2.07 1.18c.81.14 1.64-.01 2.34-.43s1.24-1.06 1.52-1.83h7.34c.27.76.81 1.42 1.52 1.83a3.473 3.473 0 0 0 4.42-.76 3.474 3.474 0 0 0 0-4.48zm-15.72 3.06c-.22.22-.51.34-.82.34s-.6-.12-.82-.34a1.15 1.15 0 0 1-.34-.82c0-.31.12-.6.34-.82s.51-.34.82-.34.6.12.82.34.34.51.34.82-.12.6-.34.82m13.89 0c-.22.22-.51.34-.82.34s-.6-.12-.82-.34a1.15 1.15 0 0 1-.34-.82c0-.31.12-.6.34-.82s.51-.34.82-.34.6.12.82.34.34.51.34.82-.12.6-.34.82"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M1.585 8.53h20.83v6.94H1.585z" />
      </clipPath>
    </defs>
  </svg>
);

/* Zoom Icon */
export const ZoomIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#343330"
      d="M21.465 20.108l-4.392-4.394a8.52 8.52 0 10-1.572 1.572l4.396 4.396a1.112 1.112 0 001.572-1.572l-.004-.002zM4.033 10.534a6.289 6.289 0 116.289 6.29 6.296 6.296 0 01-6.29-6.29z"
    />
  </svg>
);

/* Stack Icon */
export const StackIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      d="M22 21V3a1 1 0 00-1-1H3a1 1 0 00-1 1v18a1 1 0 001 1h18a1 1 0 001-1zM4 8V4h16v4H4zm0 6v-4h16v4H4zm0 6v-4h16v4H4z"
    />
  </svg>
);

/* Hide Weekends Icon */
export const HideWeekendsIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path fill="#B8B9C6" d="M3.834 3.92H8.182V20.027H3.834z" />
    <path fill="#B8B9C6" d="M15.778 3.92H20.126V20.027H15.778z" />
    <path
      fill="#262338"
      d="M21 2H3a1 1 0 00-1 1v18a1 1 0 001 1h18a1 1 0 001-1V3a1 1 0 00-1-1zM8 20H4V4h4v16zm6 0h-4V4h4v16zm6 0h-4V4h4v16z"
    />
  </svg>
);

/* Venn Icon */
export const VennIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#262338"
        d="M12 4.929a7.74 7.74 0 1 0 0 14.142A7.74 7.74 0 1 0 12 4.93m0 2.263q.476.322.884.728.477.482.834 1.06l-3.436.015c.236-.384.516-.74.834-1.06q.408-.406.884-.73zm2.447 3.776a6 6 0 0 1 0 2.064H9.553a6 6 0 0 1 0-2.064zm-4.625 6.689a5.75 5.75 0 1 1 0-11.314l-.177.177a7.76 7.76 0 0 0 .057 10.96c.056.057.127.113.184.17zm2.114-.856a6 6 0 0 1-.884-.728 6 6 0 0 1-.834-1.06h3.437c-.237.383-.517.74-.835 1.06a6 6 0 0 1-.82.721zm7.312-.735a5.77 5.77 0 0 1-5.134 1.584l.177-.177a7.76 7.76 0 0 0 .007-10.953l-.177-.177a5.75 5.75 0 0 1 5.127 9.723"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const MaleIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18z"
      fill="#E1F9FF"
    />
    <path
      d="M8 20.107C8 24.46 11.54 28 15.893 28c4.352 0 7.892-3.54 7.892-7.893a7.79 7.79 0 00-1.544-4.67l3.384-3.383v2.494a1.189 1.189 0 002.375 0v-5.36c0-.077-.008-.15-.023-.226 0-.027-.012-.058-.023-.092l-.02-.054c-.007-.027-.015-.05-.022-.073-.015-.038-.03-.065-.042-.088l-.03-.053c-.016-.031-.024-.05-.04-.07a1.249 1.249 0 00-.321-.329l-.1-.054a.683.683 0 00-.23-.095l-.091-.031A1.426 1.426 0 0026.812 8h-5.364a1.189 1.189 0 000 2.376h2.498l-3.383 3.386a7.805 7.805 0 00-4.674-1.547C11.54 12.215 8 15.755 8 20.107zm7.893-5.517a5.524 5.524 0 015.517 5.517 5.524 5.524 0 01-5.517 5.518 5.524 5.524 0 01-5.518-5.518 5.524 5.524 0 015.518-5.517z"
      fill="#117088"
    />
  </svg>
);

export const FemaleIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18z"
      fill="#F5E9F2"
    />
    <g clipPath="url(#clip0_2090_7199)">
      <path
        d="M22.88 7.613c-2.826-2.15-6.934-2.15-9.76 0C11.138 9.116 10 11.379 10 13.818c0 2.438 1.138 4.702 3.12 6.205a8.02 8.02 0 003.65 1.515v4.106h-1.867c-.68 0-1.233.541-1.233 1.208 0 .666.553 1.207 1.233 1.207h1.86v1.733c0 .663.556 1.204 1.237 1.208.33 0 .64-.128.872-.355.23-.225.358-.525.362-.852v-1.734h1.862c.33 0 .641-.125.872-.354.235-.23.362-.534.358-.85 0-.666-.553-1.207-1.233-1.207H19.23v-4.106a7.92 7.92 0 004.422-2.185 7.715 7.715 0 002.344-5.535c0-2.443-1.138-4.706-3.12-6.205l.004-.004zm.648 6.205c0 1.687-.788 3.252-2.165 4.3-.92.698-2.093 1.09-3.3 1.107a.372.372 0 00-.13 0 5.569 5.569 0 01-3.3-1.107c-1.377-1.048-2.17-2.613-2.165-4.3 0-1.687.788-3.253 2.165-4.3A5.568 5.568 0 0118 8.407c1.198 0 2.392.37 3.367 1.11 1.377 1.047 2.17 2.613 2.165 4.3h-.004z"
        fill="#E14AA4"
      />
    </g>
    <defs>
      <clipPath id="clip0_2090_7199">
        <path fill="#fff" transform="translate(10 6)" d="M0 0H16V25H0z" />
      </clipPath>
    </defs>
  </svg>
);

/* Course Icon */
export const CourseIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 25"
    width={24}
    height={25}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="currentColor"
      d="M22.466 9.732l-1.048-.648-9.43-5.888h-.115a1.023 1.023 0 00-.2-.071h-.388c-.07.016-.14.04-.209.07h-.115l-9.43 5.89a1.12 1.12 0 00-.389.431c-.093.18-.142.385-.142.593 0 .209.05.413.142.593.094.18.228.33.39.432l2.608 1.625v5.583c0 .937.331 1.835.92 2.498.59.663 1.39 1.035 2.223 1.035h8.383c.833 0 1.633-.372 2.222-1.035.59-.663.92-1.561.92-2.498v-5.583l2.096-1.319v3.368c0 .313.11.612.307.833.197.221.463.345.741.345a.993.993 0 00.741-.345c.197-.22.307-.52.307-.833v-4.051c0-.209-.05-.414-.144-.594a1.118 1.118 0 00-.39-.43zm-5.753 8.61c0 .312-.11.612-.306.832a.993.993 0 01-.741.346H7.283a.993.993 0 01-.74-.346 1.256 1.256 0 01-.307-.832v-4.275l4.725 2.944.157.07h.095a.942.942 0 00.262 0 .942.942 0 00.261 0h.095a.463.463 0 00.157-.07l4.725-2.944v4.275zm-5.239-3.698l-7.271-4.547 7.272-4.546 7.271 4.546-7.271 4.546z"
    />
  </svg>
);

/* Appointment Card Icon */
export const AppointmentCardIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g fill="#000" clipPath="url(#clip0_2314_11655)">
      <path d="M18.12 4.88C17.56 4.32 16.79 4 16 4h-1.18c-.21-.58-.59-1.09-1.09-1.45C13.22 2.19 12.62 2 12 2h-2c-.62 0-1.22.19-1.73.55-.5.36-.89.86-1.09 1.45H6c-.8 0-1.56.32-2.12.88S3 6.21 3 7v12c0 .8.32 1.56.88 2.12S5.21 22 6 22h7c.55 0 1-.45 1-1s-.45-1-1-1H6c-.27 0-.52-.11-.71-.29A.99.99 0 015 19V7c0-.27.11-.52.29-.71A.99.99 0 016 6h1v1c0 .27.11.52.29.71.19.19.44.29.71.29h6c.27 0 .52-.11.71-.29A.99.99 0 0015 7V6h1c.27 0 .52.11.71.29.19.19.29.44.29.71v4c0 .55.45 1 1 1s1-.45 1-1V7c0-.8-.32-1.56-.88-2.12zM13 6H9V5c0-.27.11-.52.29-.71A.99.99 0 0110 4h2c.27 0 .52.11.71.29.19.19.29.44.29.71v1z"></path>
      <path d="M22.71 20.29l-1.17-1.16c.37-.65.52-1.41.43-2.16-.1-.75-.44-1.44-.97-1.97-.49-.5-1.11-.85-1.8-.99a3.59 3.59 0 00-2.05.19c-.65.27-1.2.73-1.58 1.31-.38.59-.58 1.28-.57 1.98 0 .6.15 1.2.45 1.72.3.53.73.96 1.24 1.27.52.31 1.11.48 1.71.49.6 0 1.2-.14 1.73-.43l1.16 1.17c.09.09.2.17.33.22.12.05.25.08.38.08s.26-.03.38-.08.23-.13.33-.22c.09-.09.17-.2.22-.33.05-.12.08-.25.08-.38s-.03-.26-.08-.38a1.19 1.19 0 00-.22-.33zm-3.17-1.75c-.29.27-.66.42-1.06.42s-.77-.15-1.06-.42c-.28-.28-.43-.66-.43-1.05 0-.2.04-.39.11-.57.08-.18.19-.35.33-.49.27-.27.62-.42 1-.43a1.488 1.488 0 011.1.41c.15.14.26.31.34.5.08.19.12.39.11.59 0 .4-.17.77-.46 1.05l.02-.01zM14 11H8c-.27 0-.52.11-.71.29A.99.99 0 007 12c0 .27.11.52.29.71.19.19.44.29.71.29h6c.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71 0-.27-.11-.52-.29-.71A.973.973 0 0014 11zm-2 6c.27 0 .52-.11.71-.29.19-.18.29-.44.29-.71 0-.27-.11-.52-.29-.71A.973.973 0 0012 15H8c-.27 0-.52.11-.71.29A.99.99 0 007 16c0 .27.11.52.29.71.19.19.44.29.71.29h4z"></path>
    </g>
    <defs>
      <clipPath id="clip0_2314_11655">
        <path
          fill="#fff"
          d="M0 0H20.01V20.01H0z"
          transform="translate(3 2)"
        ></path>
      </clipPath>
    </defs>
  </svg>
);

/* Apply Fee Icon */
export const ApplyFeeIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <rect width="24" height="24" fill="#FFF7ED" rx="10" />
    <path
      fill="#EA580C"
      d="M18.92 6.04H5.52a.67.67 0 00-.67.67v5.36c0 .37.3.67.67.67h2v6.03c0 .37.3.67.68.67h8.04c.37 0 .67-.3.67-.67v-6.03h2c.37 0 .68-.3.68-.67V6.71a.67.67 0 00-.67-.67zM8.87 18.1v-1.34a1.34 1.34 0 011.34 1.34H8.87zm6.7 0h-1.34a1.34 1.34 0 011.34-1.34v1.34zm0-2.68a2.68 2.68 0 00-2.68 2.68h-1.34a2.68 2.68 0 00-2.68-2.68v-5.36h6.7v5.36zm2.68-4.02h-1.34v-2.01a.67.67 0 00-.67-.67H8.2a.67.67 0 00-.67.67v2h-1.34V7.98h12.06v3.42zm-6.03 3.35a2.01 2.01 0 100-4.02 2.01 2.01 0 000 4.02zm0-2.68a.67.67 0 110 1.342.67.67 0 010-1.342"
    />
  </svg>
);

/* Waive Fee Icon */
export const WaiveFeeIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <rect width="24" height="24" fill="#ECFDF5" rx="10" />
    <path
      fill="#fff"
      d="m12.066 4.646-2.518 5.088-2.871.252-.756.504-.1 6.902.956.856 11.033-.05 1.713-6.902-.806-.806-4.887-.605.353-4.181z"
    />
    <path
      fill="#059669"
      d="M19.541 10.064a2.25 2.25 0 0 0-1.725-.81h-3.42l.42-1.072a3.097 3.097 0 0 0-2.918-4.178.75.75 0 0 0-.682.443l-2.138 4.807H7.316A2.25 2.25 0 0 0 5.066 11.504v5.25a2.25 2.25 0 0 0 2.25 2.25h9.548a2.25 2.25 0 0 0 2.212-1.845l.952-5.25a2.25 2.25 0 0 0-.487-1.845M8.816 17.504h-1.5a.75.75 0 0 1-.75-.75v-5.25a.75.75 0 0 1 .75-.75h1.5zm9.75-5.865-.953 5.25a.75.75 0 0 1-.75.615h-6.547v-7.342l2.04-4.59a1.58 1.58 0 0 1 1.035 2.085l-.397 1.072a1.5 1.5 0 0 0 1.402 2.025h3.42a.75.75 0 0 1 .578.27.75.75 0 0 1 .172.615"
    />
  </svg>
);

/* Cancel Single Appointment Icon */
export const CancelSingleAppointmentIcon: FC<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <rect width="24" height="24" fill="#F1F5F9" rx="10" /> {/* slate-100 */}
    <path fill="#fff" d="M6.5 6.5h11v12h-11z" />
    <path
      fill="#334155" /* slate-700 */
      d="M17.5 5.5h-1.2a.3.3 0 01-.3-.3v-.9c0-.17-.13-.3-.3-.3h-.88a.3.3 0 00-.3.3v.9c0 .17-.13.3-.3.3H10.5a.3.3 0 01-.3-.3v-.9c0-.17-.13-.3-.3-.3H9a.3.3 0 00-.3.3v.9c0 .17-.13.3-.3.3H7.2c-.8 0-1.5.67-1.5 1.5v10.5c0 .83.7 1.5 1.5 1.5h10.3c.8 0 1.5-.67 1.5-1.5V7c0-.83-.7-1.5-1.5-1.5zm0 11.7a.3.3 0 01-.3.3H7.5a.3.3 0 01-.3-.3v-6.9c0-.17.13-.3.3-.3h9.7c.17 0 .3.13.3.3v6.9zm0-9a.3.3 0 01-.3.3H7.5a.3.3 0 01-.3-.3v-.9c0-.17.13-.3.3-.3h9.7c.17 0 .3.13.3.3v.9z"
    />
    <path
      fill="#334155" /* slate-700 */
      d="M13 12.5h-1.4c-.23 0-.4.19-.4.42v1.43c0 .23.17.42.4.42H13c.23 0 .4-.19.4-.42v-1.43c0-.23-.17-.42-.4-.42z"
    />
  </svg>
);

/* Cancel All Appointments Icon */
export const CancelAllAppointmentsIcon: FC<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <rect width="24" height="24" fill="#F1F5F9" rx="10" /> {/* slate-100 */}
    <path fill="#fff" d="M6.5 6.5h11v12h-11z" />
    <path
      fill="#334155" /* slate-700 */
      d="M17.5 5.5h-1.2a.3.3 0 01-.3-.3v-.9c0-.17-.13-.3-.3-.3h-.88a.3.3 0 00-.3.3v.9c0 .17-.13.3-.3.3H10.5a.3.3 0 01-.3-.3v-.9c0-.17-.13-.3-.3-.3H9a.3.3 0 00-.3.3v.9c0 .17-.13.3-.3.3H7.2c-.8 0-1.5.67-1.5 1.5v10.5c0 .83.7 1.5 1.5 1.5h10.3c.8 0 1.5-.67 1.5-1.5V7c0-.83-.7-1.5-1.5-1.5zm0 11.7a.3.3 0 01-.3.3H7.5a.3.3 0 01-.3-.3v-6.9c0-.17.13-.3.3-.3h9.7c.17 0 .3.13.3.3v6.9zm0-9a.3.3 0 01-.3.3H7.5a.3.3 0 01-.3-.3v-.9c0-.17.13-.3.3-.3h9.7c.17 0 .3.13.3.3v.9z"
    />
    <rect width="7.3" height="4.7" x="8.4" y="11.4" fill="#334155" rx="0.5" />{' '}
    {/* slate-700 */}
  </svg>
);

/* Cancel Appointment Range Icon */
export const CancelAppointmentRangeIcon: FC<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <rect width="24" height="24" fill="#F1F5F9" rx="10" /> {/* slate-100 */}
    <path fill="#fff" d="M6.5 6.5h11v12h-11z" />
    <path
      fill="#334155" /* slate-700 */
      d="M17.5 5.5h-1.2a.3.3 0 01-.3-.3v-.9c0-.17-.13-.3-.3-.3h-.88a.3.3 0 00-.3.3v.9c0 .17-.13.3-.3.3H10.5a.3.3 0 01-.3-.3v-.9c0-.17-.13-.3-.3-.3H9a.3.3 0 00-.3.3v.9c0 .17-.13.3-.3.3H7.2c-.8 0-1.5.67-1.5 1.5v10.5c0 .83.7 1.5 1.5 1.5h10.3c.8 0 1.5-.67 1.5-1.5V7c0-.83-.7-1.5-1.5-1.5zm0 11.7a.3.3 0 01-.3.3H7.5a.3.3 0 01-.3-.3v-6.9c0-.17.13-.3.3-.3h9.7c.17 0 .3.13.3.3v6.9zm0-9a.3.3 0 01-.3.3H7.5a.3.3 0 01-.3-.3v-.9c0-.17.13-.3.3-.3h9.7c.17 0 .3.13.3.3v.9z"
    />
    <rect width="7.3" height="1.6" x="8.4" y="11.4" fill="#334155" rx="0.5" />{' '}
    {/* slate-700 */}
    <rect
      width="4.1"
      height="1.6"
      x="8.4"
      y="14.4"
      fill="#334155"
      rx="0.5"
    />{' '}
    {/* slate-700 */}
  </svg>
);

/* Magic Icon */
export const MagicIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      stroke="#262338"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4.5 22v-5m0-10V2M2 4.5h5m-5 15h5M13 3l-1.734 4.509c-.282.733-.423 1.1-.643 1.408a3 3 0 01-.706.707c-.308.219-.675.36-1.408.642L4 12l4.509 1.734c.733.282 1.1.423 1.408.643.273.194.512.433.707.706.219.308.36.675.642 1.408L13 21l1.734-4.509c.282-.733.423-1.1.643-1.408.194-.273.433-.512.706-.707.308-.219.675-.36 1.408-.642L22 12l-4.509-1.734c-.733-.282-1.1-.423-1.408-.642a3 3 0 01-.706-.707c-.22-.308-.36-.675-.643-1.408L13 3z"
    />
  </svg>
);

/* Daily Recurring Icon */
export const DailyRecurringIcon: FC<SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    className="w-6 h-6"
  >
    <g clipPath="url(#a)">
      <path
        fill="#F8FAFC"
        d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
      />
      <path
        stroke="#334155"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        fill="none"
        d="M18.332 12.653a6.337 6.337 0 0 1-11.78 2.502l-.187-.323m-.63-3.515a6.337 6.337 0 0 1 11.78-2.502l.187.323M5.686 16.511l.547-2.037 2.038.547m7.52-5.711 2.038.547.547-2.037"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

/* Weekly Recurring Icon */
export const WeeklyRecurringIcon: FC<SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    className="w-6 h-6"
  >
    <g clipPath="url(#a)">
      <path
        fill="#EFF6FF"
        d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
      />
      <path
        stroke="#1D4ED8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        fill="none"
        d="M18.332 12.653a6.337 6.337 0 0 1-11.78 2.502l-.187-.323m-.63-3.515a6.337 6.337 0 0 1 11.78-2.502l.187.323M5.686 16.511l.547-2.037 2.038.547m7.52-5.711 2.038.547.547-2.037"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

/* Fortnightly Recurring Icon */
export const FortnightlyRecurringIcon: FC<SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    className="w-6 h-6"
  >
    <g clipPath="url(#a)">
      <path
        fill="#F0F9FF"
        d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
      />
      <path
        stroke="#0369A1"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        fill="none"
        d="M18.332 12.653a6.337 6.337 0 0 1-11.78 2.502l-.187-.323m-.63-3.515a6.337 6.337 0 0 1 11.78-2.502l.187.323M5.686 16.511l.547-2.037 2.038.547m7.52-5.711 2.038.547.547-2.037"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

/* Monthly Recurring Icon */
export const MonthlyRecurringIcon: FC<SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    className="w-6 h-6"
  >
    <g clipPath="url(#a)">
      <path
        fill="#ECFEFF"
        d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
      />
      <path
        stroke="#0D9488"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        fill="none"
        d="M18.332 12.653a6.337 6.337 0 0 1-11.78 2.502l-.187-.323m-.63-3.515a6.337 6.337 0 0 1 11.78-2.502l.187.323M5.686 16.511l.547-2.037 2.038.547m7.52-5.711 2.038.547.547-2.037"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

/* Custom Recurring Icon */
export const CustomRecurringIcon: FC<SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    className="w-6 h-6"
  >
    <g clipPath="url(#a)">
      <path
        fill="#FFFBEB"
        d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
      />
      <path
        stroke="#CA8A04"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        fill="none"
        d="M18.332 12.653a6.337 6.337 0 0 1-11.78 2.502l-.187-.323m-.63-3.515a6.337 6.337 0 0 1 11.78-2.502l.187.323M5.686 16.511l.547-2.037 2.038.547m7.52-5.711 2.038.547.547-2.037"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

/* Infinity Icon */
export const InfinityIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="currentColor"
      d="m12.158 13.444.073.073c.898.852 1.777 1.685 2.053 1.94 1.097 1.027 2.426 1.586 3.63 1.54 1.89-.077 3.424-.915 4.323-2.355.852-1.36 1.002-3.09.391-4.51-.813-1.894-2.317-2.975-4.352-3.117-1.447-.104-3.133.652-4.513 2.018a.26.26 0 0 0-.084.188.28.28 0 0 0 .072.194l.905.96a.27.27 0 0 0 .356.032l.378-.278c.376-.282.698-.522 1.029-.69 1.412-.73 2.99-.467 3.926.655.548.66.779 1.436.692 2.311-.14 1.374-1.275 2.396-2.76 2.489-1.863.124-3.01-1.018-4.12-2.118l-.241-.24-2.077-1.98-.073-.073q-1.023-.974-2.054-1.94c-1.094-1.027-2.414-1.59-3.627-1.54-1.888.081-3.424.914-4.326 2.357-.848 1.359-.997 3.092-.387 4.512.814 1.895 2.318 2.971 4.353 3.118 1.442.104 3.132-.652 4.513-2.019a.276.276 0 0 0 .011-.382l-.905-.96a.27.27 0 0 0-.357-.031l-.377.277c-.375.282-.702.525-1.028.695-1.412.729-2.99.463-3.926-.655a2.9 2.9 0 0 1-.586-1.075c-.12-.4-.156-.822-.106-1.237.14-1.374 1.275-2.397 2.76-2.488 1.874-.117 3.01 1.017 4.118 2.117l.243.24 2.077 1.979z"
    />
  </svg>
);
/* Plus Minus Icon */
export const PlusMinusIcon: FC<SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    className="w-6 h-6"
  >
    <path fill="#fff" d="M4.09 4.475h17.051v16.999H4.09z" />
    <path
      fill="#1E293B"
      d="M11.366 7.969h-1v-1a1 1 0 1 0-2 0v1h-1a1 1 0 1 0 0 2h1v1a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2m2 11h4a1 1 0 0 0 0-2h-4a1 1 0 0 0 0 2m6-16h-14a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-14a3 3 0 0 0-3-3m-15 16.59V5.969a1 1 0 0 1 1-1h13.59zm16 .41a1 1 0 0 1-1 1H5.776l14.59-14.59z"
    />
  </svg>
);

/* Exact Appointment Icon */
export const ExactAppointmentIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.088 3.077H15.4a.433.433 0 0 1-.422-.44v-1.32c0-.242-.19-.44-.422-.44h-1.267a.433.433 0 0 0-.422.44v1.32c0 .242-.19.44-.422.44h-5.49a.433.433 0 0 1-.422-.44v-1.32c0-.242-.19-.44-.423-.44H4.844a.433.433 0 0 0-.423.44v1.32c0 .242-.19.44-.422.44H2.31c-1.16 0-2.11.99-2.11 2.2v15.4c0 1.21.95 2.2 2.11 2.2h14.778c1.161 0 2.111-.99 2.111-2.2v-15.4c0-1.21-.95-2.2-2.11-2.2m0 17.16c0 .242-.19.44-.422.44H2.733a.433.433 0 0 1-.423-.44v-10.12c0-.242.19-.44.423-.44h13.933c.232 0 .422.198.422.44zm0-13.2c0 .242-.19.44-.422.44H2.733a.433.433 0 0 1-.423-.44v-1.32c0-.242.19-.44.423-.44h13.933c.232 0 .422.198.422.44z"
    />
    <path
      fill="currentColor"
      d="M10.704 13.273H8.698a.605.605 0 0 0-.591.617v2.09c0 .34.264.616.59.616h2.006a.604.604 0 0 0 .59-.616v-2.09a.604.604 0 0 0-.59-.616"
    />
  </svg>
);

/* Google Maps Icon */
export const GoogleMapsIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path fill="#fff" d="M0 0h24v24H0z" />
    <g clipPath="url(#a)">
      <path
        fill="#34A753"
        d="M12.62 23h-.291c-.123-.033-.261-.03-.35-.146-.062-.082-.124-.163-.169-.258a3 3 0 0 1-.122-.312c-.174-.518-.327-1.044-.53-1.552-.286-.71-.671-1.362-1.089-1.997-.292-.445-.6-.877-.91-1.307-.03-.04-.068-.075-.06-.132.042-.145.153-.244.243-.353.428-.52.851-1.044 1.28-1.562q.692-.834 1.378-1.673c.57-.696 1.143-1.388 1.71-2.085.157-.194.301-.401.494-.565.065-.055.088-.148.137-.219.2-.189.364-.411.528-.633.167-.083.233-.26.344-.394l.985-1.2.813-.99.85-1.038c.323-.394.649-.785.968-1.182.059-.074.123-.143.182-.217.037-.046.084-.08.148-.065.08.042.1.128.134.201.31.673.53 1.374.646 2.11.039.238.047.48.05.72.01.604.03 1.21-.037 1.81a8.3 8.3 0 0 1-.648 2.367c-.452 1.046-1.094 1.968-1.772 2.866-.642.85-1.316 1.677-1.94 2.541-.446.619-.874 1.25-1.254 1.913a9.6 9.6 0 0 0-.737 1.666c-.134.388-.238.786-.388 1.168-.035.089-.083.17-.129.253-.102.189-.27.248-.463.265"
      />
      <path
        fill="#FABB04"
        d="M9.139 17.294 8.112 15.97c-.62-.8-1.242-1.597-1.765-2.47a9 9 0 0 1-.607-1.174c0-.074.033-.129.08-.186q.54-.655 1.078-1.312.487-.596.976-1.189.405-.495.812-.989c.34-.41.67-.83 1.017-1.235.05-.059.094-.124.15-.18.029-.03.056-.06.102-.056q.03.003.051.024c.053.08-.002.144-.033.208q-.296.617-.285 1.301c.01.667.224 1.264.634 1.78.426.537.98.867 1.639.998.803.159 1.535-.03 2.198-.517l.127-.095c.036-.026.073-.039.11-.001l-.426.528q-.298.37-.598.737c-.188.229-.38.454-.568.683-.244.298-.479.605-.729.897-.188.219-.369.443-.552.665-.247.3-.488.606-.735.906-.194.236-.395.465-.588.7-.236.29-.461.587-.704.87-.122.142-.236.29-.357.432"
      />
      <path
        fill="#4284F3"
        d="M14.736 1.355a7.3 7.3 0 0 1 2.886 1.734 7.6 7.6 0 0 1 1.487 2.002q.01.022.018.045l-3.08 3.752-1.071 1.305q-.045.05-.094.097c-.052-.06-.009-.108.018-.157.26-.478.406-.987.386-1.536a2.86 2.86 0 0 0-.731-1.853 2.68 2.68 0 0 0-1.671-.907c-.855-.12-1.61.117-2.261.7-.044.039-.081.098-.155.072-.064-.058-.016-.102.018-.148.193-.25.398-.49.598-.735q.556-.682 1.115-1.362c.36-.44.726-.879 1.086-1.32.367-.448.737-.892 1.099-1.343q.106-.128.213-.255a.26.26 0 0 1 .14-.09z"
      />
      <path
        fill="#E94335"
        d="M10.29 6.786c-.052.078-.102.157-.174.219-.056.07-.082.166-.173.207q-.553.672-1.103 1.346-.41.504-.829 1-.47.55-.918 1.117c-.273.347-.56.683-.834 1.028q-.252.318-.519.622a8.2 8.2 0 0 1-.614-2.045 9.5 9.5 0 0 1-.125-1.371L5 8.482a7.8 7.8 0 0 1 .705-3.063c.279-.606.62-1.172 1.053-1.678.075-.025.124.024.173.066q1.057.913 2.116 1.826c.395.342.798.676 1.185 1.028.037.034.077.065.058.125"
      />
      <path
        fill="#1A73E7"
        d="M10.29 6.786 6.758 3.741a7 7 0 0 1 1.716-1.547c1.444-.936 3.021-1.312 4.72-1.162a6.5 6.5 0 0 1 1.542.323q-.366.457-.735.91c-.367.45-.737.895-1.104 1.343l-1.235 1.506-1.188 1.449q-.009.015-.016.033z"
      />
      <path
        fill="#FABB04"
        d="m9.943 7.212.174-.207c-.017.083-.073.143-.116.21z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M5 1h15v22H5z" />
      </clipPath>
    </defs>
  </svg>
);

/* Add Ons Icon */
export const AddOnsIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path d="M16.2996 7.59998H7.59961V16.3H16.2996V7.59998Z" fill="white" />
    <path
      fill="#E14AA4"
      d="M21.6244 11.0774L19.3216 8.78313V5.79061C19.3216 5.19211 18.8209 4.5936 18.1201 4.5936H15.0162L12.8134 2.39909C12.3128 1.90034 11.6119 1.90034 11.2114 2.39909L9.00866 4.5936H5.80465C5.2039 4.5936 4.60315 5.09236 4.60315 5.79061V8.98263L2.30027 11.2769C1.79965 11.7756 1.79965 12.4739 2.30027 12.8729L4.60315 15.1672V18.2594C4.60315 18.8579 5.10378 19.4564 5.80465 19.4564H8.90853L11.1113 21.651C11.6119 22.1497 12.3128 22.1497 12.7133 21.651L14.916 19.4564H18.1201C18.7208 19.4564 19.3216 18.9577 19.3216 18.2594V14.9677L21.6244 12.6734C22.0249 12.2744 22.0249 11.5761 21.6244 11.0774ZM14.5155 13.3717H14.3153H13.4142V14.4689C13.4142 15.2669 12.7133 15.9652 11.9123 15.9652C11.1113 15.9652 10.4104 15.2669 10.4104 14.4689V13.3717H9.60941H9.40916C8.60816 13.3717 7.90728 12.6734 7.90728 11.8754C7.90728 11.0774 8.60816 10.3791 9.40916 10.3791H9.60941H10.5105V9.38163C10.5105 8.68338 11.2114 7.98512 12.0124 7.98512C12.8134 7.98512 13.5143 8.68338 13.5143 9.48138V10.5786H14.4154H14.6157C15.4167 10.5786 16.1175 11.2769 16.1175 12.0749C16.1175 12.8729 15.3165 13.3717 14.5155 13.3717Z"
    />
  </svg>
);

/* Hard Forced Icon */
export const HardForcedIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g clipPath="url(#clip0_2380_9107)">
      <rect x="2" y="5" width="16" height="14" fill="white" />
      <path
        d="M18.5797 2H5.42027C3.53057 2 2 3.53057 2 5.42027V10.6875H13.2954L10.277 7.66909C9.75545 7.1475 9.75545 6.35229 10.277 5.8307C10.7986 5.30911 11.5938 5.30911 12.1154 5.8307L17.3655 11.0808C17.8871 11.6024 17.8871 12.3976 17.3655 12.9192L12.1154 18.1693C11.5938 18.6909 10.7986 18.6909 10.277 18.1693C9.75545 17.6477 9.75545 16.8525 10.277 16.3309L13.2954 13.3125H2V18.5797C2 20.4694 3.53057 22 5.42027 22H18.5712C20.4609 22 21.9914 20.4694 21.9914 18.5797V5.42027C21.9914 3.53057 20.4609 2 18.5712 2H18.5797Z"
        fill="#E4740C"
      />
    </g>
    <defs>
      <clipPath id="clip0_2380_9107">
        <rect width="20" height="20" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);

/* Customer Notes Icon */
export const CustomerNotesIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g clipPath="url(#clip0_4202_4082)">
      <path
        d="M4.01703 20.5522L5.55473 18.2557L3.00854 13.4029L4.27664 6.60313L10.2377 3.19824H15.1703L20.702 9.06944V14.5113L17.5567 19.1044L10.8368 20.5522H4.01703Z"
        fill="white"
      />
      <path
        d="M19.0744 4.92561C17.1972 3.04843 14.661 2 12.015 2C10.7069 2 9.40889 2.25961 8.19071 2.75886C6.98253 3.25811 5.87419 3.997 4.95557 4.92561C3.07838 6.79281 2.02996 9.33899 2.02996 11.985C2.02996 14.2916 2.81877 16.5282 4.28657 18.3055L2.28957 20.3025C2.14978 20.4423 2.05991 20.6221 2.01997 20.8118C1.98003 21.0015 2 21.2012 2.07988 21.3909C2.15976 21.5706 2.29955 21.7204 2.4693 21.8203C2.63904 21.9201 2.83874 21.97 3.02846 21.97H12.015C14.661 21.97 17.2072 20.9216 19.0744 19.0444C20.9516 17.1672 22 14.6311 22 11.985C22 9.33899 20.9516 6.79281 19.0744 4.92561ZM17.0774 18.1558C15.6495 19.334 13.8622 19.973 12.015 19.973H5.43485L6.36345 19.0444C6.55317 18.8547 6.65302 18.6051 6.65302 18.3355C6.65302 18.0659 6.55317 17.8163 6.36345 17.6266C5.05542 16.3185 4.24663 14.6011 4.05691 12.7639C3.87718 10.9266 4.3365 9.07938 5.36495 7.54169C6.39341 6.00399 7.92112 4.8657 9.68847 4.3365C11.4558 3.7973 13.353 3.88717 15.0604 4.59611C16.7678 5.30504 18.1757 6.58313 19.0544 8.21068C19.9231 9.83824 20.2027 11.7254 19.8432 13.5327C19.4838 15.35 18.5052 16.9775 17.0774 18.1558Z"
        fill="#E14AA4"
      />
      <path
        d="M7.24219 10.9366C7.24219 10.2477 7.52177 9.58867 8.01103 9.0994C8.5003 8.62012 9.1693 8.35052 9.85826 8.36051C10.677 8.36051 11.4559 8.7 11.9951 9.30908C12.5342 8.7 13.3131 8.35052 14.1319 8.36051C14.8208 8.35052 15.4898 8.61013 15.9791 9.0994C16.4683 9.57868 16.7479 10.2377 16.7479 10.9366C16.7479 13.4828 13.7125 15.4099 11.9951 16.9277C10.2776 15.39 7.24219 13.4828 7.24219 10.9366Z"
        fill="#E14AA4"
      />
    </g>
    <defs>
      <clipPath id="clip0_4202_4082">
        <rect
          width="20"
          height="19.97"
          fill="white"
          transform="translate(2 2)"
        />
      </clipPath>
    </defs>
  </svg>
);

/* Private Notes Icon */
export const PrivateNotesIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      d="M10 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H10V7C10 7.79565 10.3161 8.55871 10.8787 9.12132C11.4413 9.68393 12.2044 10 13 10H17C17.1974 9.99901 17.3901 9.93961 17.5539 9.82928C17.7176 9.71895 17.845 9.56262 17.92 9.38C17.9966 9.19789 18.0175 8.99718 17.9801 8.80319C17.9428 8.6092 17.8488 8.43062 17.71 8.29L11.71 2.29C11.6273 2.21222 11.5328 2.14808 11.43 2.1C11.4002 2.09576 11.3699 2.09576 11.34 2.1L11.06 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20436 22 5 22H10C10.2652 22 10.5196 21.8946 10.7071 21.7071C10.8946 21.5196 11 21.2652 11 21C11 20.7348 10.8946 20.4804 10.7071 20.2929C10.5196 20.1054 10.2652 20 10 20ZM12 5.41L14.59 8H13C12.7348 8 12.4804 7.89464 12.2929 7.70711C12.1054 7.51957 12 7.26522 12 7V5.41ZM13 13C13 12.7348 12.8946 12.4804 12.7071 12.2929C12.5196 12.1054 12.2652 12 12 12H7C6.73478 12 6.48043 12.1054 6.29289 12.2929C6.10536 12.4804 6 12.7348 6 13C6 13.2652 6.10536 13.5196 6.29289 13.7072C6.48043 13.8947 6.73478 14.0001 7 14.0001H13C13.2652 14.0001 13.5196 13.8947 13.7071 13.7072C13.8947 13.5196 14 13.2653 14 13.0001C14 12.7349 13.8947 12.4805 13.7071 12.293C13.5196 12.1054 13.2652 12.0001 13 12.0001ZM7 10H8C8.26522 10 8.51957 9.89464 8.70711 9.70711C8.89464 9.51957 9 9.26522 9 9C9 8.73478 8.89464 8.48043 8.70711 8.29289C8.51957 8.10536 8.26522 8 8 8H7C6.73478 8 6.48043 8.10536 6.29289 8.29289C6.10536 8.48043 6 8.73478 6 9C6 9.26522 6.10536 9.51957 6.29289 9.70711C6.48043 9.89464 6.73478 10 7 10ZM7 16C6.73478 16 6.48043 16.1054 6.29289 16.2929C6.10536 16.4804 6 16.7348 6 17C6 17.2652 6.10536 17.5196 6.29289 17.7071C6.48043 17.8946 6.73478 18 7 18H9C9.26522 18 9.51957 17.8946 9.70711 17.7071C9.89464 17.5196 10 17.2652 10 17C10 16.7348 9.89464 16.4804 9.70711 16.2929C9.51957 16.1054 9.26522 16 9 16H7Z"
      fill="#262338"
    />
  </svg>
);

/* Map Pin Icon */
export const MapPinIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

/* Phone Icon */
export const PhoneIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      d="M19.4102 13C19.1902 13 18.9602 12.93 18.7402 12.88C18.295 12.7805 17.8573 12.6501 17.4302 12.49C16.9663 12.3212 16.4563 12.33 15.9985 12.5146C15.5406 12.6992 15.1673 13.0466 14.9502 13.49L14.7302 13.95C13.759 13.3992 12.8618 12.7271 12.0602 11.95C11.283 11.1484 10.611 10.2512 10.0602 9.28L10.5202 9.07C10.9635 8.85292 11.311 8.47953 11.4956 8.02169C11.6802 7.56385 11.6889 7.05391 11.5202 6.59C11.3614 6.15903 11.2311 5.71808 11.1302 5.27C11.0802 5.05 11.0402 4.82 11.0102 4.6C10.8887 3.89562 10.5198 3.25774 9.96979 2.80124C9.41979 2.34474 8.72487 2.09961 8.01017 2.11H5.00017C4.57742 2.10945 4.15932 2.19825 3.77329 2.37058C3.38726 2.54292 3.04201 2.7949 2.76017 3.11C2.47249 3.43365 2.25829 3.81575 2.13228 4.23004C2.00626 4.64432 1.97143 5.08098 2.03017 5.51C2.57376 9.67214 4.47538 13.5387 7.44017 16.51C10.4115 19.4748 14.278 21.3764 18.4402 21.92C18.57 21.9299 18.7004 21.9299 18.8302 21.92C19.5676 21.9211 20.2796 21.6505 20.8302 21.16C21.1453 20.8782 21.3973 20.5329 21.5696 20.1469C21.7419 19.7609 21.8307 19.3428 21.8302 18.92V15.92C21.8248 15.229 21.581 14.5611 21.1401 14.0291C20.6992 13.4971 20.0881 13.1336 19.4102 13Z"
      fill="#262338"
    />
  </svg>
);

/* Pre Auth Icon */
export const PreAuthIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#5D5FEF"
      d="M15 22H5a2.9 2.9 0 0 1-2.12-.926c-.57-.6-.88-1.39-.88-2.232v-7.368c0-.842.31-1.632.88-2.232A2.9 2.9 0 0 1 5 8.316h1V7.263c0-.842.31-1.631.88-2.231A2.9 2.9 0 0 1 9 4.105h1c.55 0 1 .474 1 1.053s-.45 1.053-1 1.053H9c-.27 0-.52.105-.71.305S8 6.979 8 7.263v7.369c0 .284.1.547.29.747s.44.305.71.305h10c.26 0 .52-.116.71-.305.19-.2.29-.463.29-.747V7.263c0-.274-.11-.547-.29-.747A.97.97 0 0 0 19 6.21h-1c-.55 0-1-.474-1-1.053 0-.58.45-1.053 1-1.053h1c.8 0 1.55.327 2.12.927s.88 1.39.88 2.231v7.369c0 .842-.31 1.631-.88 2.231a2.9 2.9 0 0 1-2.12.927h-1v1.052c0 .842-.31 1.632-.88 2.232A2.9 2.9 0 0 1 15 22M5 10.421c-.27 0-.52.105-.71.305s-.29.463-.29.748v7.368c0 .284.1.548.29.748s.44.305.71.305h10c.26 0 .52-.116.71-.305.19-.2.29-.464.29-.748V17.79H9a2.9 2.9 0 0 1-2.12-.927c-.57-.6-.88-1.39-.88-2.231v-4.21zm9 3.158a1.003 1.003 0 0 1-.71-.316l-3-3.158a1.09 1.09 0 0 1 0-1.484.96.96 0 0 1 1.41 0l1.29 1.358V3.053c0-.58.45-1.053 1-1.053s1 .474 1 1.053v6.936l1.29-1.357a.96.96 0 0 1 1.41 0c.39.41.39 1.073 0 1.484l-3 3.158a1 1 0 0 1-.71.316z"
    />
  </svg>
);

/* Invoice Icon */
export const InvoiceIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      d="M3 3.5V19.5L5 21L20.5 20.5L20 13.5H17L16 3.5L13 5.5L12 4H10H9L6.5 5L3 3.5Z"
      fill="white"
    />
    <path
      d="M13 16.0001H7.00001C6.73479 16.0001 6.48044 16.1054 6.2929 16.293C6.10537 16.4805 6.00001 16.7349 6.00001 17.0001C6.00001 17.2653 6.10537 17.5196 6.2929 17.7072C6.48044 17.8947 6.73479 18.0001 7.00001 18.0001H13C13.2652 18.0001 13.5196 17.8947 13.7071 17.7072C13.8947 17.5196 14 17.2653 14 17.0001C14 16.7349 13.8947 16.4805 13.7071 16.293C13.5196 16.1054 13.2652 16.0001 13 16.0001ZM9.00001 10.0001H11C11.2652 10.0001 11.5196 9.89471 11.7071 9.70717C11.8947 9.51964 12 9.26528 12 9.00007C12 8.73485 11.8947 8.4805 11.7071 8.29296C11.5196 8.10543 11.2652 8.00007 11 8.00007H9.00001C8.73479 8.00007 8.48044 8.10543 8.2929 8.29296C8.10537 8.4805 8.00001 8.73485 8.00001 9.00007C8.00001 9.26528 8.10537 9.51964 8.2929 9.70717C8.48044 9.89471 8.73479 10.0001 9.00001 10.0001ZM21 12.0001H18V3.00007C18.0007 2.82386 17.9548 2.65059 17.867 2.49781C17.7792 2.34504 17.6526 2.21817 17.5 2.13007C17.348 2.0423 17.1755 1.99609 17 1.99609C16.8245 1.99609 16.652 2.0423 16.5 2.13007L13.5 3.85007L10.5 2.13007C10.348 2.0423 10.1755 1.99609 10 1.99609C9.82447 1.99609 9.65203 2.0423 9.50001 2.13007L6.50001 3.85007L3.50001 2.13007C3.34799 2.0423 3.17554 1.99609 3.00001 1.99609C2.82447 1.99609 2.65203 2.0423 2.50001 2.13007C2.3474 2.21817 2.22079 2.34504 2.13299 2.49781C2.04518 2.65059 1.99931 2.82386 2.00001 3.00007V19.0001C2.00001 19.7957 2.31608 20.5588 2.87869 21.1214C3.4413 21.684 4.20436 22.0001 5.00001 22.0001H19C19.7957 22.0001 20.5587 21.684 21.1213 21.1214C21.6839 20.5588 22 19.7957 22 19.0001V13.0001C22 12.7349 21.8947 12.4805 21.7071 12.293C21.5196 12.1054 21.2652 12.0001 21 12.0001ZM5.00001 20.0001C4.73479 20.0001 4.48044 19.8947 4.2929 19.7072C4.10536 19.5196 4.00001 19.2653 4.00001 19.0001V4.73007L6.00001 5.87007C6.15435 5.95068 6.32589 5.99278 6.50001 5.99278C6.67413 5.99278 6.84567 5.95068 7.00001 5.87007L10 4.15007L13 5.87007C13.1543 5.95068 13.3259 5.99278 13.5 5.99278C13.6741 5.99278 13.8457 5.95068 14 5.87007L16 4.73007V19.0001C16.0027 19.3412 16.0636 19.6794 16.18 20.0001H5.00001ZM20 19.0001C20 19.2653 19.8947 19.5196 19.7071 19.7072C19.5196 19.8947 19.2652 20.0001 19 20.0001C18.7348 20.0001 18.4804 19.8947 18.2929 19.7072C18.1054 19.5196 18 19.2653 18 19.0001V14.0001H20V19.0001ZM13 12.0001H7.00001C6.73479 12.0001 6.48044 12.1054 6.2929 12.293C6.10537 12.4805 6.00001 12.7349 6.00001 13.0001C6.00001 13.2653 6.10537 13.5196 6.2929 13.7072C6.48044 13.8947 6.73479 14.0001 7.00001 14.0001H13C13.2652 14.0001 13.5196 13.8947 13.7071 13.7072C13.8947 13.5196 14 13.2653 14 13.0001C14 12.7349 13.8947 12.4805 13.7071 12.293C13.5196 12.1054 13.2652 12.0001 13 12.0001Z"
      fill="#5D5FEF"
    />
  </svg>
);

/* Charge Card Icon */
export const ChargeCardIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#5D5FEF"
      d="M23 15.726c0 1.245 0 1.931-.344 2.598a3.15 3.15 0 0 1-1.375 1.372c-.677.343-1.355.343-2.602.343h-4.823c.413.461.403 1.177-.049 1.618a1.184 1.184 0 0 1-1.67 0l-1.964-1.96a1.2 1.2 0 0 1-.344-.805v-.039c0-.147.03-.294.089-.431.059-.138.147-.275.255-.383l1.964-1.96a1.181 1.181 0 0 1 1.72 1.617h4.822c.736 0 1.365 0 1.532-.088a.83.83 0 0 0 .344-.343c.088-.167.088-.804.088-1.53v-4.51H3.357v4.51c0 .736 0 1.363.089 1.53a.83.83 0 0 0 .343.343c.167.088.796.088 1.532.088H7.09c.648 0 1.179.53 1.179 1.177s-.53 1.176-1.179 1.176H5.321c-1.247 0-1.934 0-2.602-.343a3.1 3.1 0 0 1-1.375-1.373C1 17.657 1 16.981 1 15.735v-7.45c0-1.246 0-1.932.344-2.599a3.1 3.1 0 0 1 1.375-1.372c.668-.343 1.355-.343 2.602-.343h4.823a1.17 1.17 0 0 1 .049-1.618 1.18 1.18 0 0 1 1.67 0l1.964 1.96c.118.118.196.246.255.383.06.128.088.275.088.422v.039c0 .147-.029.294-.088.431a1.2 1.2 0 0 1-.255.383l-1.964 1.96a1.181 1.181 0 0 1-1.72-1.617H5.322c-.736 0-1.365 0-1.532.088a.83.83 0 0 0-.343.343c-.089.167-.089.775-.089 1.53v.588h17.286v-.588c0-.736 0-1.363-.088-1.53a.83.83 0 0 0-.344-.343c-.167-.088-.806-.088-1.532-.088H16.91c-.649 0-1.179-.53-1.179-1.177s.53-1.176 1.179-1.176h1.768c1.247 0 1.934 0 2.602.343a3.1 3.1 0 0 1 1.375 1.373C23 6.343 23 7.03 23 8.275"
    />
  </svg>
);

/* Change Appointment Icon */
export const ChangeAppointmentIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="#262338"
      d="M19 22H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1.6a.4.4 0 0 0 .4-.4V2.4c0-.22.18-.4.4-.4h1.2c.22 0 .4.18.4.4v1.2c0 .22.18.4.4.4h5.2a.4.4 0 0 0 .4-.4V2.4c0-.22.18-.4.4-.4h1.2c.22 0 .4.18.4.4v1.2c0 .22.18.4.4.4H19a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2M5.4 10a.4.4 0 0 0-.4.4v9.2c0 .22.18.4.4.4h13.2a.4.4 0 0 0 .4-.4v-9.2a.4.4 0 0 0-.4-.4zm0-4a.4.4 0 0 0-.4.4v1.2c0 .22.18.4.4.4h13.2a.4.4 0 0 0 .4-.4V6.4a.4.4 0 0 0-.4-.4zm4.517 12.883a.4.4 0 0 1-.282.117H8.4a.4.4 0 0 1-.4-.4v-1.234a.4.4 0 0 1 .117-.283l3.8-3.79a.4.4 0 0 1 .566 0l1.234 1.234a.4.4 0 0 1 0 .566zm4.71-4.7-.003-.002-1.516-1.515a.4.4 0 0 1 .001-.567l.808-.804a.4.4 0 0 1 .565 0l1.235 1.235a.4.4 0 0 1 0 .566l-1.085 1.085z"
    />
  </svg>
);

/* Cancel Appointment Icon */
export const CancelAppointmentIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <rect x="4" y="5" width="16" height="16" fill="white" />
    <path
      d="M19 22H5C3.89543 22 3 21.1046 3 20V6C3 4.89543 3.89543 4 5 4H6.6C6.82091 4 7 3.82091 7 3.6V2.4C7 2.17909 7.17909 2 7.4 2H8.6C8.82091 2 9 2.17909 9 2.4V3.6C9 3.82091 9.17909 4 9.4 4H14.6C14.8209 4 15 3.82091 15 3.6V2.4C15 2.17909 15.1791 2 15.4 2H16.6C16.8209 2 17 2.17909 17 2.4V3.6C17 3.82091 17.1791 4 17.4 4H19C20.1046 4 21 4.89543 21 6V20C21 21.1046 20.1046 22 19 22ZM5.4 10C5.17909 10 5 10.1791 5 10.4V19.6C5 19.8209 5.17909 20 5.4 20H18.6C18.8209 20 19 19.8209 19 19.6V10.4C19 10.1791 18.8209 10 18.6 10H5.4ZM5.4 6C5.17909 6 5 6.17909 5 6.4V7.6C5 7.82091 5.17909 8 5.4 8H18.6C18.8209 8 19 7.82091 19 7.6V6.4C19 6.17909 18.8209 6 18.6 6H5.4Z"
      fill="currentColor"
    />
    <path
      d="M14.518 11.7913C14.4399 11.7132 14.3133 11.7132 14.2351 11.7913L12.1247 13.9018C12.0466 13.9799 11.9199 13.9799 11.8418 13.9018L9.73132 11.7913C9.65322 11.7132 9.52659 11.7132 9.44848 11.7913L8.79132 12.4485C8.71322 12.5266 8.71322 12.6532 8.79132 12.7313L10.9018 14.8418C10.9799 14.9199 10.9799 15.0466 10.9018 15.1247L8.79132 17.2351C8.71322 17.3133 8.71322 17.4399 8.79132 17.518L9.44848 18.1751C9.52659 18.2533 9.65322 18.2533 9.73132 18.1751L11.8418 16.0647C11.9199 15.9866 12.0466 15.9866 12.1247 16.0647L14.2351 18.1751C14.3133 18.2533 14.4399 18.2533 14.518 18.1751L15.1751 17.518C15.2533 17.4399 15.2533 17.3133 15.1751 17.2351L13.0647 15.1247C12.9866 15.0466 12.9866 14.9199 13.0647 14.8418L15.1751 12.7313C15.2533 12.6532 15.2533 12.5266 15.1751 12.4485L14.518 11.7913Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.3"
    />
  </svg>
);

/* Refund Icon */
export const RefundIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#E4740C"
      d="M12 12a3 3 0 1 0 0 5.999A3 3 0 0 0 12 12m0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-.71-6.29a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 1 1 0 0 0 .33-.21L15 7.46A1.032 1.032 0 1 0 13.54 6l-.54.59V3a1 1 0 0 0-2 0v3.59L10.46 6A1.032 1.032 0 1 0 9 7.46zM19 15a1 1 0 1 0-2 0 1 1 0 0 0 2 0m1-7h-3a1 1 0 1 0 0 2h3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h3a1 1 0 0 0 0-2H4a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-8a3 3 0 0 0-3-3M5 15a1 1 0 1 0 2 0 1 1 0 0 0-2 0"
    />
  </svg>
);

/* Pie Chart Icon */
export const PieChartIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2m0 2c4 0 7.4 3 7.9 7H12zm4 14.9L12.6 13H20c-.4 2.5-1.8 4.7-4 5.9"
    />
  </svg>
);

/* Card Terminal Icon */
export const CardTerminalIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      d="M17.1878 1H6.81219C5.26552 1 4 2.21807 4 3.70673V20.2933C4 21.7819 5.26552 23 6.81219 23H17.1878C18.7345 23 20 21.7819 20 20.2933V3.70673C20 2.21807 18.7345 1 17.1878 1Z"
      fill="#5D5FEF"
    />
  </svg>
);

/* Card Tap Icon */
export const CardTapIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      d="M19.3,1.5c-1.3-0.5-2.8-0.5-4.1,0c-1.3,0.5-2.5,1.4-3.2,2.6c-0.2,0.3-0.2,0.6,0,0.9c0.2,0.3,0.5,0.5,0.8,0.5 c0,0,0,0,0,0c0.3,0,0.6-0.2,0.8-0.5c0.5-0.8,1.3-1.4,2.2-1.8c0.9-0.3,1.9-0.3,2.8,0c0.8,0.3,2.1,1.6,2.2,1.8 c0.2,0.3,0.5,0.4,0.8,0.4c0.2,0,0.3,0,0.5-0.1c0.2-0.1,0.4-0.3,0.4-0.6c0.1-0.2,0-0.5-0.1-0.7C21.7,2.9,20.6,1.9,19.3,1.5z"
      fill="#5D5FEF"
    />
    <path
      d="M12.6,14H6.4C6.2,14,6,14.2,6,14.4v1.2C6,15.8,6.2,16,6.4,16h6.2c0.2,0,0.4-0.2,0.4-0.4v-1.2 C13,14.2,12.8,14,12.6,14z"
      fill="#5D5FEF"
    />
  </svg>
);

/* Resource Icon */
export const ResourceIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      d="M7 22H4.6c-.65 0-1.08 0-1.51-.22-.38-.19-.68-.49-.87-.87C2 20.48 2 20.05 2 19.4v-1.74c0-.29 0-.49.06-.72.05-.2.13-.4.24-.57.12-.2.26-.34.47-.55l5.11-5.11c.14-.14.22-.22.28-.29-.02-.04-.05-.21-.09-.49a7.008 7.008 0 0 1 6.94-7.94c3.86 0 7 3.14 7 7a7.008 7.008 0 0 1-7.94 6.94c-.28-.04-.43-.06-.56-.07 0 .03-.08.12-.21.25l-1.58 1.58a1 1 0 0 1-.71.29h-1v1c0 .55-.45 1-1 1h-1v1c0 .55-.45 1-1 1zm8-18c-2.76 0-5 2.24-5 5 0 .23.02.45.04.68.07.52.11.79.07 1.06-.04.26-.1.46-.23.69-.14.24-.31.41-.59.7l-5.11 5.11c-.09.09-.15.14-.19.19 0 .03.01.11.01.23v1.74c0 .28 0 .57.02.65.01-.05.3-.05.58-.05H6v-1c0-.55.45-1 1-1h1v-1c0-.55.45-1 1-1h1.59l1.29-1.29c.29-.29.45-.45.69-.59.24-.13.44-.2.7-.24.28-.04.54 0 1.06.07.22.03.45.04.67.04 2.76 0 5-2.24 5-5s-2.24-5-5-5zm2 6c-.55 0-1-.45-1-1a.99.99 0 0 0-1-1c-.55 0-1-.45-1-1s.45-1 1-1c.8 0 1.55.31 2.12.88S18 8.2 18 9c0 .55-.45 1-1 1"
    />
  </svg>
);

/* Show Active Only Icon */
export const ShowActiveOnlyIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#B8B9C6"
      d="M10.686 3.92h4.348v16.107h-4.348zM16.607 3.92h4.348v16.107h-4.348z"
    />
    <path
      fill="#262338"
      d="M21.83 2h-18a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1m-13 18h-4V4h4zm6 0h-4V4h4zm6 0h-4V4h4z"
    />
  </svg>
);

/* Cancel Card Icon */
export const CancelCardIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g clipPath="url(#clip0_2288_10007)">
      <path
        d="M20.63 5.71997C20.85 5.71997 21.03 5.89997 21.03 6.11997V7.31997C21.03 7.53997 20.85 7.71997 20.63 7.71997H10.82L15.86 11.72H20.64C20.86 11.72 21.04 11.9 21.04 12.12V15.83L23.04 17.42V5.71997C23.04 4.61997 22.14 3.71997 21.04 3.71997H5.78003L8.30003 5.71997H20.64H20.63Z"
        fill="#FD0000"
      />
      <path
        d="M22.9601 19.41L2.58011 3.21004C2.16011 2.88004 1.55011 2.95004 1.21011 3.37004C0.870113 3.79004 0.950113 4.40004 1.37011 4.74004L3.03011 6.06004V17.72C3.03011 18.82 3.93011 19.72 5.03011 19.72H20.2201L21.7501 20.93C22.1701 21.26 22.7801 21.19 23.1201 20.77C23.4601 20.35 23.3801 19.74 22.9601 19.4V19.41Z"
        fill="#FD0000"
      />
    </g>
    <defs>
      <clipPath id="clip0_2288_10007">
        <rect
          width="22.33"
          height="18.14"
          fill="white"
          transform="translate(1 3)"
        />
      </clipPath>
    </defs>
  </svg>
);

/* Bank Icon */
export const BankIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#5D5FEF"
      d="M19 8.38c.13 0 .26-.03.38-.08s.23-.13.32-.23.17-.21.22-.34.08-.26.08-.4V4.19c0-.22-.07-.43-.19-.61s-.3-.31-.49-.38l-9-3.15a.97.97 0 0 0-.63 0L.68 3.2c-.2.07-.37.2-.49.38a1.1 1.1 0 0 0-.19.61v3.14a1.1 1.1 0 0 0 .3.74c.09.1.2.17.32.23.12.05.25.08.38.08h1v7.53c-.58.22-1.09.61-1.45 1.14-.35.53-.55 1.16-.55 1.81v2.1a1.1 1.1 0 0 0 .3.74c.09.1.2.17.32.23.12.05.25.08.38.08h18c.13 0 .26-.03.38-.08s.23-.13.32-.23.17-.21.22-.34.08-.26.08-.4v-2.1c0-.65-.2-1.28-.55-1.81-.36-.53-.86-.93-1.45-1.14V8.38zM18 19.9H2v-1.05c0-.28.11-.54.29-.74.19-.2.44-.31.71-.31h14c.27 0 .52.11.71.31s.29.46.29.74zM4 15.71V8.38h2v7.33zm4 0V8.38h4v7.33zm6 0V8.38h2v7.33zM2 6.29V4.95l8-2.79 8 2.79v1.34z"
    />
  </svg>
);

/* Hidden Icon */
export const HiddenIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      d="M12.001 15C13.6578 15 15.001 13.6569 15.001 12C15.001 10.3431 13.6578 9 12.001 9C10.3441 9 9.00098 10.3431 9.00098 12C9.00098 13.6569 10.3441 15 12.001 15Z"
      fill="#262338"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.32439 11.4467C2.81164 6.97571 7.02889 3.75 12.0015 3.75C16.9718 3.75 21.1874 6.97271 22.6765 11.4405C22.7969 11.8015 22.797 12.1922 22.6769 12.5533C21.1896 17.0243 16.9723 20.25 11.9997 20.25C7.02945 20.25 2.81381 17.0273 1.32472 12.5595C1.20437 12.1985 1.20426 11.8078 1.32439 11.4467ZM17.251 12C17.251 14.8995 14.9005 17.25 12.001 17.25C9.10148 17.25 6.75098 14.8995 6.75098 12C6.75098 9.1005 9.10148 6.75 12.001 6.75C14.9005 6.75 17.251 9.1005 17.251 12Z"
      fill="#262338"
    />
  </svg>
);

/* Visible Icon */
export const VisibleIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      d="M12.001 15C13.6578 15 15.001 13.6569 15.001 12C15.001 10.3431 13.6578 9 12.001 9C10.3441 9 9.00098 10.3431 9.00098 12C9.00098 13.6569 10.3441 15 12.001 15Z"
      fill="#262338"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.32439 11.4467C2.81164 6.97571 7.02889 3.75 12.0015 3.75C16.9718 3.75 21.1874 6.97271 22.6765 11.4405C22.7969 11.8015 22.797 12.1922 22.6769 12.5533C21.1896 17.0243 16.9723 20.25 11.9997 20.25C7.02945 20.25 2.81381 17.0273 1.32472 12.5595C1.20437 12.1985 1.20426 11.8078 1.32439 11.4467ZM17.251 12C17.251 14.8995 14.9005 17.25 12.001 17.25C9.10148 17.25 6.75098 14.8995 6.75098 12C6.75098 9.1005 9.10148 6.75 12.001 6.75C14.9005 6.75 17.251 9.1005 17.251 12Z"
      fill="#262338"
    />
  </svg>
);

/* Currency Icon */
export const CurrencyIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-5 h-5', props.className)}
    fill="currentColor"
    {...props}
  >
    <path d="M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18.33c-4.59 0-8.33-3.74-8.33-8.33S7.41 3.67 12 3.67s8.33 3.74 8.33 8.33-3.74 8.33-8.33 8.33z" />
    <path d="M12.63 11.21V9.33c.76.19.93.69.95.76.07.33.41.54.74.48.34-.07.56-.4.49-.74-.07-.56-.72-1.55-2.18-1.77v-.64c0-.35-.28-.62-.62-.62s-.62.28-.62.62v.62c-2.22.22-2.44 1.61-2.46 1.9-.02.28-.07 1.03.5 1.65.42.45 1.07.71 1.96.79v2.21c-.89-.12-1.19-.47-1.21-.66 0-.34-.28-.62-.62-.62s-.62.28-.62.62c0 .07.03 1.68 2.46 1.92v.73c0 .34.28.62.62.62s.62-.28.62-.62v-.75c1.82-.22 2.5-1.37 2.5-2.38s-.68-2.05-2.5-2.25zm-2.29-.47c-.18-.19-.19-.45-.17-.71.02-.29.37-.62 1.21-.73v1.83c-.49-.06-.86-.19-1.04-.39zm2.29 3.84v-2.13c.61.09 1.25.33 1.25 1 0 .3-.14.95-1.25 1.13z" />
  </svg>
);

/* Preview Document Icon */
export const PreviewDocumentIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      d="M12 20H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h3v1a1 1 0 0 0 2 0V8.94a1.3 1.3 0 0 0-.06-.27v-.09a1 1 0 0 0-.19-.28l-6-6a1 1 0 0 0-.28-.19.3.3 0 0 0-.09 0 .9.9 0 0 0-.33-.11H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h7a1 1 0 0 0 0-2m0-14.59L14.59 8H13a1 1 0 0 1-1-1zM7 8a1 1 0 0 0 0 2h1a1 1 0 0 0 0-2zm14.71 12.29-1.17-1.16A3.44 3.44 0 0 0 20 15a3.49 3.49 0 0 0-6 2.49 3.46 3.46 0 0 0 5.13 3.05l1.16 1.17a1.002 1.002 0 0 0 1.639-.325 1 1 0 0 0-.219-1.095m-3.17-1.75a1.54 1.54 0 0 1-2.11 0 1.5 1.5 0 0 1 .01-2.11 1.48 1.48 0 0 1 1-.43A1.47 1.47 0 0 1 19 17.49a1.5 1.5 0 0 1-.46 1.05M13 12H7a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m-2 6a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2z"
    />
  </svg>
);

/* Cash Icon */
export const CashIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#279559"
      d="M22 2H2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h3v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-9h3a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1M7 20v-2a2 2 0 0 1 2 2zm10 0h-2a2 2 0 0 1 2-2zm0-4a4 4 0 0 0-4 4h-2a4 4 0 0 0-4-4V8h10zm4-6h-2V7a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3H3V4h18zm-9 5a3 3 0 1 0 0-5.999A3 3 0 0 0 12 15m0-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
    />
  </svg>
);

/* Bank Transfer Received Icon */
export const BankTransferReceivedIcon: FC<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#279559"
      d="M19.25 9.167a.916.916 0 0 0 .917-.917V5.5a.915.915 0 0 0-.627-.87l-8.25-2.75a.92.92 0 0 0-.58 0L2.46 4.63a.92.92 0 0 0-.627.87v2.75a.916.916 0 0 0 .917.917h.917v6.585a2.745 2.745 0 0 0-1.834 2.581v1.834a.916.916 0 0 0 .917.916h16.5a.916.916 0 0 0 .917-.916v-1.834a2.75 2.75 0 0 0-1.834-2.58V9.166zm-.917 10.083H3.667v-.917a.92.92 0 0 1 .916-.916h12.834a.92.92 0 0 1 .916.916zM5.5 15.583V9.167h1.833v6.416zm3.667 0V9.167h3.666v6.416zm5.5 0V9.167H16.5v6.416zm-11-8.25V6.161L11 3.716l7.333 2.445v1.172z"
    />
  </svg>
);

/* Up Arrow Circle Icon */
export const DownCircleIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2m3.7 10.7-3 3c-.1.1-.2.2-.3.2-.2.1-.5.1-.8 0-.1 0-.2-.1-.3-.2l-3-3c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l1.3 1.3V9.053c0-.58.45-1.053 1-1.053s1 .474 1 1.053v6.936l1.29-1.357a.96.96 0 0 1 1.41 0c.39.41.39 1.073 0 1.484l-3 3.158a1 1 0 0 1-.71.316z"
    />
  </svg>
);

/* Down Arrow Circle Icon */
export const UpCircleIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2m3.7 10.7c-.4.4-1 .4-1.4 0L13 11.4V15c0 .6-.4 1-1 1s-1-.4-1-1v-3.6l-1.3 1.3c-.4.4-1 .4-1.4 0s-.4-1 0-1.4l3-3c.4-.4 1-.4 1.4 0l3 3c.4.4.4 1 0 1.4"
    />
  </svg>
);

/* Late Level One Icon */
export const LateLevelOneIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2m3.1 9.4-2.6 1.5c-.5.3-1.1.1-1.4-.4-.1-.2-.1-.3-.1-.5V7c0-.6.4-1 1-1s1 .4 1 1v3.3l1.1-.6c.5-.3 1.1-.1 1.4.4s.1 1-.4 1.3"
    />
  </svg>
);

/* Late Level Two Icon */
export const LateLevelTwoIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#262338"
      d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2m3 11h-3c-.6 0-1-.4-1-1V7c0-.6.4-1 1-1s1 .4 1 1v4h2c.6 0 1 .4 1 1s-.4 1-1 1"
    />
  </svg>
);

/* Morning Icon */
export const MorningIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 37 37"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <circle cx="18.5" cy="18.5" r="18.5" fill="#FFF7ED" />{' '}
    {/* Tailwind equivalent for #FFF8F0 -> orange-50 */}
    <path
      d="M20.0607 10.4231C19.7794 10.1522 19.3978 10 19 10C18.6022 10 18.2207 10.1522 17.9394 10.4231C17.658 10.694 17.5 11.0614 17.5 11.4444V12.8889C17.5 13.272 17.658 13.6394 17.9394 13.9103C18.2207 14.1812 18.6022 14.3333 19 14.3333C19.3978 14.3333 19.7794 14.1812 20.0607 13.9103C20.342 13.6394 20.5 13.272 20.5 12.8889V11.4444C20.5 11.0614 20.342 10.694 20.0607 10.4231Z"
      fill="#FB923C" // Tailwind equivalent for #FCB659 -> orange-400
    />
    <path
      d="M23.883 23C25 23 25 23.0879 25 21.5556C25 20.0232 24.3679 18.5536 23.2427 17.47C22.1174 16.3865 20.5913 15.7778 19 15.7778C17.4087 15.7778 15.8826 16.3865 14.7574 17.47C13.6322 18.5536 13 20.0232 13 21.5556C13 23.0879 13 23 15.25 23H23.883Z"
      fill="#FB923C" // Tailwind equivalent for #FCB659 -> orange-400
    />
    <path
      d="M27.9232 14.4056C27.9232 14.0225 27.7652 13.6552 27.484 13.3843C27.2027 13.1135 26.8228 12.9614 26.425 12.9614C26.0273 12.9614 25.6458 13.1135 25.3645 13.3843L24.304 14.4056C24.1607 14.5388 24.0465 14.6982 23.9679 14.8744C23.8892 15.0506 23.8479 15.2402 23.8461 15.432C23.8444 15.6238 23.8824 15.814 23.9578 15.9915C24.0332 16.169 24.1446 16.3303 24.2854 16.4659C24.4263 16.6015 24.5937 16.7088 24.7781 16.7814C24.9624 16.854 25.1599 16.8906 25.3591 16.8889C25.5583 16.8873 25.7551 16.8474 25.9381 16.7717C26.1211 16.696 26.2866 16.586 26.425 16.448L27.484 15.4268C27.7652 15.1559 27.9232 14.7886 27.9232 14.4056Z"
      fill="#FB923C" // Tailwind equivalent for #FCB659 -> orange-400
    />
    <path
      d="M12.0616 16.7613C11.8796 16.6887 11.7143 16.5822 11.575 16.448L10.5145 15.4268C10.2413 15.1544 10.0901 14.7895 10.0935 14.4108C10.0969 14.032 10.2547 13.6697 10.5328 13.4019C10.8109 13.1341 11.1871 12.9822 11.5804 12.9789C11.9737 12.9756 12.3526 13.1212 12.6355 13.3843L13.6975 14.4056C13.8368 14.5398 13.9472 14.6991 14.0226 14.8744C14.0979 15.0497 14.1366 15.2376 14.1366 15.4273C14.1365 15.617 14.0976 15.8049 14.0222 15.9801C13.9467 16.1554 13.8361 16.3146 13.6968 16.4487C13.5574 16.5828 13.392 16.6892 13.2099 16.7617C13.0279 16.8343 12.8328 16.8716 12.6357 16.8715C12.4387 16.8714 12.2436 16.834 12.0616 16.7613Z"
      fill="#FB923C" // Tailwind equivalent for #FCB659 -> orange-400
    />
    <rect x="9" y="21" width="20" height="2" rx="1" fill="#FB923C" />{' '}
    {/* Tailwind equivalent for #FCB659 -> orange-400 */}
  </svg>
);

/* Afternoon Icon */
export const AfternoonIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 37 37"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <circle cx="18.5" cy="18.5" r="18.5" fill="#FFEDD5" />{' '}
    {/* Tailwind equivalent for #FFF5E9 */}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.5 8.67456C18.8257 8.67456 19.1381 8.80396 19.3685 9.03429C19.5988 9.26462 19.7282 9.57702 19.7282 9.90275V11.1309C19.7282 11.4567 19.5988 11.7691 19.3685 11.9994C19.1381 12.2297 18.8257 12.3591 18.5 12.3591C18.1743 12.3591 17.8619 12.2297 17.6315 11.9994C17.4012 11.7691 17.2718 11.4567 17.2718 11.1309V9.90275C17.2718 9.57702 17.4012 9.26462 17.6315 9.03429C17.8619 8.80396 18.1743 8.67456 18.5 8.67456V8.67456ZM23.4128 18.5001C23.4128 19.803 22.8952 21.0526 21.9738 21.9739C21.0525 22.8953 19.8029 23.4129 18.5 23.4129C17.1971 23.4129 15.9475 22.8953 15.0261 21.9739C14.1048 21.0526 13.5872 19.803 13.5872 18.5001C13.5872 17.1971 14.1048 15.9476 15.0261 15.0262C15.9475 14.1049 17.1971 13.5873 18.5 13.5873C19.8029 13.5873 21.0525 14.1049 21.9738 15.0262C22.8952 15.9476 23.4128 17.1971 23.4128 18.5001V18.5001ZM22.8429 24.5796L23.7112 25.448C23.9429 25.6717 24.2531 25.7955 24.5751 25.7927C24.8972 25.7899 25.2052 25.6607 25.4329 25.433C25.6606 25.2053 25.7898 24.8972 25.7926 24.5752C25.7954 24.2532 25.6716 23.9429 25.4479 23.7113L24.5795 22.843C24.3479 22.6193 24.0377 22.4955 23.7156 22.4983C23.3936 22.5011 23.0856 22.6302 22.8578 22.8579C22.6301 23.0857 22.501 23.3937 22.4982 23.7157C22.4954 24.0378 22.6192 24.348 22.8429 24.5796V24.5796ZM25.4466 11.5522C25.6769 11.7825 25.8062 12.0949 25.8062 12.4205C25.8062 12.7462 25.6769 13.0586 25.4466 13.2889L24.5795 14.1572C24.4662 14.2745 24.3307 14.3681 24.1809 14.4324C24.031 14.4968 23.8699 14.5307 23.7068 14.5321C23.5437 14.5335 23.382 14.5025 23.231 14.4407C23.0801 14.3789 22.943 14.2877 22.8277 14.1724C22.7123 14.0571 22.6211 13.92 22.5594 13.769C22.4976 13.6181 22.4666 13.4564 22.468 13.2933C22.4694 13.1302 22.5033 12.9691 22.5676 12.8192C22.632 12.6694 22.7256 12.5338 22.8429 12.4205L23.7112 11.5522C23.9415 11.322 24.2539 11.1926 24.5795 11.1926C24.9052 11.1926 25.2176 11.322 25.4479 11.5522H25.4466ZM27.0973 19.7283C27.4231 19.7283 27.7355 19.5989 27.9658 19.3686C28.1961 19.1382 28.3255 18.8258 28.3255 18.5001C28.3255 18.1744 28.1961 17.862 27.9658 17.6316C27.7355 17.4013 27.4231 17.2719 27.0973 17.2719H25.8691C25.5434 17.2719 25.231 17.4013 25.0007 17.6316C24.7704 17.862 24.641 18.1744 24.641 18.5001C24.641 18.8258 24.7704 19.1382 25.0007 19.3686C25.231 19.5989 25.5434 19.7283 25.8691 19.7283H27.0973ZM18.5 24.641C18.8257 24.641 19.1381 24.7704 19.3685 25.0008C19.5988 25.2311 19.7282 25.5435 19.7282 25.8692V27.0974C19.7282 27.4232 19.5988 27.7356 19.3685 27.9659C19.1381 28.1962 18.8257 28.3256 18.5 28.3256C18.1743 28.3256 17.8619 28.1962 17.6315 27.9659C17.4012 27.7356 17.2718 27.4232 17.2718 27.0974V25.8692C17.2718 25.5435 17.4012 25.2311 17.6315 25.0008C17.8619 24.7704 18.1743 24.641 18.5 24.641V24.641ZM12.4205 14.1572C12.5345 14.2713 12.6699 14.3619 12.8189 14.4236C12.9679 14.4854 13.1276 14.5173 13.289 14.5173C13.4503 14.5174 13.61 14.4857 13.7591 14.424C13.9082 14.3623 14.0436 14.2719 14.1577 14.1578C14.2718 14.0438 14.3624 13.9084 14.4242 13.7594C14.4859 13.6104 14.5178 13.4506 14.5178 13.2893C14.5179 13.128 14.4862 12.9682 14.4245 12.8192C14.3628 12.6701 14.2724 12.5347 14.1583 12.4205L13.2888 11.5522C13.0571 11.3285 12.7469 11.2047 12.4249 11.2075C12.1028 11.2103 11.7948 11.3395 11.5671 11.5672C11.3394 11.7949 11.2102 12.1029 11.2074 12.425C11.2046 12.747 11.3284 13.0572 11.5521 13.2889L12.4205 14.1572V14.1572ZM14.1571 24.5796L13.2888 25.448C13.0571 25.6717 12.7469 25.7955 12.4249 25.7927C12.1028 25.7899 11.7948 25.6607 11.5671 25.433C11.3394 25.2053 11.2102 24.8972 11.2074 24.5752C11.2046 24.2532 11.3284 23.9429 11.5521 23.7113L12.4205 22.843C12.6521 22.6193 12.9623 22.4955 13.2844 22.4983C13.6064 22.5011 13.9144 22.6302 14.1422 22.8579C14.3699 23.0857 14.499 23.3937 14.5018 23.7157C14.5046 24.0378 14.3808 24.348 14.1571 24.5796V24.5796ZM11.1309 19.7283C11.4566 19.7283 11.769 19.5989 11.9993 19.3686C12.2296 19.1382 12.359 18.8258 12.359 18.5001C12.359 18.1744 12.2296 17.862 11.9993 17.6316C11.769 17.4013 11.4566 17.2719 11.1309 17.2719H9.90266C9.57692 17.2719 9.26453 17.4013 9.0342 17.6316C8.80387 17.862 8.67447 18.1744 8.67447 18.5001C8.67447 18.8258 8.80387 19.1382 9.0342 19.3686C9.26453 19.5989 9.57692 19.7283 9.90266 19.7283H11.1309Z"
      fill="#F97316" // Tailwind equivalent for #F78500
    />
  </svg>
);

/* Evening Icon */
export const EveningIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 37 37"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <circle cx={18} cy={18} r={18} fill="#F0F6FF" />
    <g clipPath="url(#a)">
      <path
        fill="#1559D1"
        d="M10.703 16.763c.1-.527.158-1.06.295-1.58.712-2.547 2.281-4.343 4.714-5.367q.12-.046.237-.08c.022-.007.044.008.08.015-.886 3.123-.396 5.966 1.943 8.296 2.325 2.323 5.146 2.806 8.298 1.911-.295.88-.698 1.66-1.274 2.33-2.224 2.59-5.03 3.579-8.312 2.698-3.254-.88-5.19-3.116-5.837-6.442-.058-.28-.094-.562-.137-.843q-.009-.475-.007-.938"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M10.703 9.73H26.27v15.568H10.703z" />
      </clipPath>
    </defs>
  </svg>
);

/* Plus Icon */
export const PlusIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3.5}
      d="M12 5v14m-7-7h14"
    />
  </svg>
);

/* Red Place Circle Location Icon */
export const RedPlaceCircleLocationIcon: FC<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g clipPath="url(#red_place_circle_a)">
      <path
        fill="#FFE9E8"
        d="M18 36c9.941 0 18-8.059 18-18S27.941 0 18 0 0 8.059 0 18s8.059 18 18 18z"
      />
      <g clipPath="url(#red_place_circle_b)">
        <path
          fill="#FF5349"
          d="M12.337 10.279a7.75 7.75 0 0 0-2.296 4.729 7.68 7.68 0 0 0 1.272 5.082l5.662 8.372c.111.166.263.301.441.395a1.25 1.25 0 0 0 1.163 0c.179-.094.33-.23.442-.395l5.662-8.372a7.64 7.64 0 0 0 1.225-5.473 7.76 7.76 0 0 0-2.854-4.862 8.15 8.15 0 0 0-5.462-1.746 8.1 8.1 0 0 0-5.255 2.27M18 20.433a4.9 4.9 0 0 1-2.681-.792 4.73 4.73 0 0 1-1.778-2.11 4.6 4.6 0 0 1-.275-2.717 4.67 4.67 0 0 1 1.321-2.408 4.87 4.87 0 0 1 2.471-1.287 4.94 4.94 0 0 1 2.789.267 4.8 4.8 0 0 1 2.165 1.733c.53.773.813 1.682.813 2.613a4.64 4.64 0 0 1-1.413 3.324 4.9 4.9 0 0 1-3.412 1.377"
        />
        <path
          fill="#fff"
          d="M18 20.434c2.664 0 4.825-2.105 4.825-4.703 0-2.597-2.16-4.702-4.826-4.702s-4.826 2.105-4.826 4.703c0 2.597 2.16 4.702 4.826 4.702"
        />
      </g>
    </g>
    <defs>
      <clipPath id="red_place_circle_a">
        <path fill="#fff" d="M0 0h36v36H0z" />
      </clipPath>
      <clipPath id="red_place_circle_b">
        <path fill="#fff" d="M10 8h16v21H10z" />
      </clipPath>
    </defs>
  </svg>
);

/* Pre-saved Location Icon */
export const PreSavedLocationIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g clipPath="url(#presaved_location)">
      <path
        fill="#DEE4F3"
        d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"
      />
      <ellipse cx={16.051} cy={20.963} fill="#fff" rx={7.09} ry={4.07} />
      <circle cx={16.003} cy={9.954} r={3.289} fill="#fff" />
      <path
        fill="#262338"
        d="M20.37 16.79a1.001 1.001 0 0 0-.74 1.86C21.09 19.23 22 20.13 22 21c0 1.42-2.46 3-6 3s-6-1.58-6-3c0-.87.91-1.77 2.37-2.35a1 1 0 1 0-.74-1.86C9.36 17.69 8 19.26 8 21c0 2.8 3.51 5 8 5s8-2.2 8-5c0-1.74-1.36-3.31-3.63-4.21M15 13.86V21a1 1 0 0 0 2 0v-7.14a4 4 0 1 0-2 0M16 8a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
      />
    </g>
    <defs>
      <clipPath id="presaved_location">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);

/* Bulk Edit Icon */
export const BulkEditIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    fill="none"
    {...props}
  >
    <g clipPath="url(#bulk_edit_a)">
      <path
        stroke="#262338"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.4}
        d="m6 15 2 2 4.5-4.5M8 8V5.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C9.52 2 10.08 2 11.2 2h7.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 3.52 22 4.08 22 5.2v7.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 16 19.92 16 18.8 16H16M5.2 22h7.6c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C16 20.48 16 19.92 16 18.8v-7.6c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C14.48 8 13.92 8 12.8 8H5.2c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C2 9.52 2 10.08 2 11.2v7.6c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874C3.52 22 4.08 22 5.2 22"
      />
    </g>
    <defs>
      <clipPath id="bulk_edit_a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

/* Edit Icon */
export const EditIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21 12a1 1 0 0 0-1 1v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h6a1 1 0 1 0 0-2H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1m-15 .76V17a1 1 0 0 0 1 1h4.24a1 1 0 0 0 .71-.29l6.92-6.93L21.71 8a1 1 0 0 0 0-1.42l-4.24-4.29a1 1 0 0 0-1.42 0l-2.82 2.83-6.94 6.93a1 1 0 0 0-.29.71m10.76-8.35 2.83 2.83-1.42 1.42-2.83-2.83zM8 13.17l5.93-5.93 2.83 2.83L10.83 16H8z"
    />
  </svg>
);

/* Insurance Icon */
export const InsuranceIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    className={cn('w-full h-full', props.className)}
    fill="none"
    {...props}
  >
    <g transform="translate(4, 3)">
      <path
        fill="currentColor"
        d="M15.63 1.65a1 1 0 0 0-.84-.2A8 8 0 0 1 8.57.18a1 1 0 0 0-1.14 0 8 8 0 0 1-6.22 1.27A1 1 0 0 0 0 2.43v7.45a9 9 0 0 0 3.77 7.33l3.65 2.6a1 1 0 0 0 1.16 0l3.65-2.6A9 9 0 0 0 16 9.88V2.43a1 1 0 0 0-.37-.78M14 9.88a7 7 0 0 1-2.93 5.7L8 17.77l-3.07-2.19A7 7 0 0 1 2 9.88v-6.3a10 10 0 0 0 6-1.39 10 10 0 0 0 6 1.39zM9.54 7.59l-2.69 2.7-.89-.9a1.004 1.004 0 0 0-1.42 1.42l1.6 1.6a1 1 0 0 0 1.42 0L11 9a1.004 1.004 0 0 0-1.42-1.42z"
      />
    </g>
  </svg>
);

/* Insurance Expiry Icon */
export const InsuranceExpiryIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.92 13a.6.6 0 0 0-.09-.17l-.12-.15a1 1 0 0 0-1.42 0 .6.6 0 0 0-.12.15.6.6 0 0 0-.09.17.7.7 0 0 0-.06.19 1 1 0 0 0 0 .19.9.9 0 0 0 .08.39 1 1 0 0 0 1.3.54 1.2 1.2 0 0 0 .33-.22 1 1 0 0 0 .21-.32 1 1 0 0 0 .08-.39 1 1 0 0 0 0-.19.7.7 0 0 0-.1-.19M8 5.36a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1m7.63-3.71a1 1 0 0 0-.84-.2A8 8 0 0 1 8.57.18a1 1 0 0 0-1.14 0 8 8 0 0 1-6.22 1.27A1 1 0 0 0 0 2.43v7.45a9 9 0 0 0 3.77 7.33l3.65 2.6a1 1 0 0 0 1.16 0l3.65-2.6A9 9 0 0 0 16 9.88V2.43a1 1 0 0 0-.37-.78M14 9.88a7 7 0 0 1-2.93 5.7L8 17.77l-3.07-2.19A7 7 0 0 1 2 9.88v-6.3a10 10 0 0 0 6-1.39 10 10 0 0 0 6 1.39z"
    />
  </svg>
);

/* Certificate Badge Icon */
export const CertificateBadgeIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="m17.87 15.25-2.71-4.68a7 7 0 1 0-12.32 0L.13 15.25a1 1 0 0 0 .87 1.5h2.87l1.46 2.46q.075.123.18.22a1 1 0 0 0 .69.28h.14a1 1 0 0 0 .73-.49L9 15.9l1.93 3.35a1 1 0 0 0 .73.48h.14a1 1 0 0 0 .7-.28.9.9 0 0 0 .17-.21l1.46-2.46H17a1 1 0 0 0 .87-.5 1 1 0 0 0 0-1.03M6.19 16.78l-.89-1.49a1 1 0 0 0-.85-.49H2.72l1.43-2.48a7 7 0 0 0 3.57 1.84zM9 12.25a5 5 0 1 1 0-9.999 5 5 0 0 1 0 9.999m4.55 2.55a1 1 0 0 0-.85.49l-.89 1.49-1.52-2.65a7.06 7.06 0 0 0 3.56-1.84l1.43 2.48z"
    />
  </svg>
);

/* Certificate Icon */
export const CertificateIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="m17.87 15.25-2.71-4.68a7 7 0 1 0-12.32 0L.13 15.25a1 1 0 0 0 .87 1.5h2.87l1.46 2.46q.075.123.18.22a1 1 0 0 0 .69.28h.14a1 1 0 0 0 .73-.49L9 15.9l1.93 3.35a1 1 0 0 0 .73.48h.14a1 1 0 0 0 .7-.28.9.9 0 0 0 .17-.21l1.46-2.46H17a1 1 0 0 0 .87-.5 1 1 0 0 0 0-1.03M6.19 16.78l-.89-1.49a1 1 0 0 0-.85-.49H2.72l1.43-2.48a7 7 0 0 0 3.57 1.84zM9 12.25a5 5 0 1 1 0-9.999 5 5 0 0 1 0 9.999m4.55 2.55a1 1 0 0 0-.85.49l-.89 1.49-1.52-2.65a7.06 7.06 0 0 0 3.56-1.84l1.43 2.48z"
    />
  </svg>
);

/* Institution Icon */
export const InstitutionIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.09 7.848a.916.916 0 0 0 .916-.916v-2.75a.92.92 0 0 0-.627-.87L10.13.562a.9.9 0 0 0-.58 0L1.3 3.312a.92.92 0 0 0-.626.87v2.75a.916.916 0 0 0 .916.916h.917v6.586a2.745 2.745 0 0 0-1.833 2.58v1.834a.916.916 0 0 0 .916.917h16.5a.92.92 0 0 0 .917-.917v-1.833a2.745 2.745 0 0 0-1.833-2.581V7.848zm-.917 10.084H2.506v-.917a.917.917 0 0 1 .917-.917h12.833a.917.917 0 0 1 .917.917zM4.339 14.265V7.848h1.834v6.417zm3.667 0V7.848h3.667v6.417zm5.5 0V7.848h1.833v6.417zm-11-8.25V4.842l7.333-2.445 7.334 2.445v1.173z"
    />
  </svg>
);

/* Book Icon */
export const BookIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      d="M21.17 2.06012C20.4532 1.93665 19.7274 1.8731 19.0001 1.87012C16.5184 1.86809 14.0886 2.5797 12.0001 3.92012C9.90624 2.5973 7.47674 1.90315 5.00008 1.92012C4.27274 1.9231 3.54688 1.98665 2.83008 2.11012C2.5953 2.1506 2.38266 2.27358 2.2305 2.45692C2.07834 2.64024 1.99662 2.87188 2.00008 3.11012V15.1101C1.99794 15.2571 2.02822 15.4027 2.08874 15.5366C2.14926 15.6705 2.23856 15.7894 2.35026 15.8849C2.46196 15.9803 2.59334 16.05 2.73504 16.089C2.87674 16.1279 3.02528 16.1351 3.17008 16.1101C4.6031 15.862 6.07128 15.9032 7.48816 16.2312C8.90502 16.5592 10.2419 17.1675 11.4201 18.0201L11.5401 18.0901H11.6501C11.761 18.1363 11.8799 18.1601 12.0001 18.1601C12.1202 18.1601 12.2392 18.1363 12.3501 18.0901H12.4601L12.5801 18.0201C13.75 17.1484 15.0831 16.5205 16.5002 16.1735C17.9174 15.8265 19.3897 15.7675 20.83 16.0001C20.9748 16.0251 21.1234 16.0179 21.2652 15.979C21.4068 15.94 21.5382 15.8703 21.65 15.7749C21.7616 15.6794 21.851 15.5605 21.9114 15.4266C21.972 15.2927 22.0022 15.1471 22 15.0001V3.00012C21.9896 2.77228 21.9016 2.55484 21.7508 2.38386C21.5998 2.21288 21.3948 2.09866 21.17 2.06012ZM11.0001 15.3501C9.14996 14.3768 7.0906 13.8688 5.00008 13.8701C4.67008 13.8701 4.34008 13.8701 4.00008 13.8701V3.87012C4.33314 3.85092 4.66702 3.85092 5.00008 3.87012C7.13348 3.86776 9.2203 4.49382 11.0001 5.67012V15.3501ZM20 13.9101C19.6601 13.9101 19.3301 13.9101 19.0001 13.9101C16.9096 13.9088 14.8502 14.4168 13.0001 15.3901V5.67012C14.7799 4.49382 16.8667 3.86776 19.0001 3.87012C19.3331 3.85092 19.667 3.85092 20 3.87012V13.9101ZM21.17 18.0601C20.4532 17.9367 19.7274 17.8731 19.0001 17.8701C16.5184 17.8681 14.0886 18.5797 12.0001 19.9201C9.9116 18.5797 7.48172 17.8681 5.00008 17.8701C4.27274 17.8731 3.54688 17.9367 2.83008 18.0601C2.69992 18.0808 2.5751 18.127 2.46284 18.196C2.35058 18.2651 2.25308 18.3557 2.17596 18.4625C2.09882 18.5694 2.04358 18.6905 2.01338 18.8188C1.98321 18.9471 1.97869 19.0801 2.00008 19.2101C2.0509 19.4698 2.20258 19.6988 2.42188 19.8468C2.64118 19.9949 2.91022 20.0501 3.17008 20.0001C4.6031 19.752 6.07128 19.7932 7.48816 20.1211C8.90502 20.4493 10.2419 21.0575 11.4201 21.9101C11.5894 22.0307 11.7922 22.0955 12.0001 22.0955C12.208 22.0955 12.4107 22.0307 12.5801 21.9101C13.7583 21.0575 15.0952 20.4493 16.512 20.1211C17.9289 19.7932 19.3971 19.752 20.83 20.0001C21.09 20.0501 21.359 19.9949 21.5782 19.8468C21.7976 19.6988 21.9492 19.4698 22 19.2101C22.0214 19.0801 22.017 18.9471 21.9868 18.8188C21.9566 18.6905 21.9014 18.5694 21.8242 18.4625C21.747 18.3557 21.6496 18.2651 21.5374 18.196C21.425 18.127 21.3002 18.0808 21.17 18.0601Z"
      fill="#262338"
    />
  </svg>
);

/* Next Appointment Icon */
export const NextAppointmentIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g clipPath="url(#clip0_2754_9261)">
      <path
        d="M19 4H17.4C17.18 4 17 3.82 17 3.6V2.4C17 2.18 16.82 2 16.6 2H15.4C15.18 2 15 2.18 15 2.4V3.6C15 3.82 14.82 4 14.6 4H9.4C9.18 4 9 3.82 9 3.6V2.4C9 2.18 8.82 2 8.6 2H7.4C7.18 2 7 2.18 7 2.4V3.6C7 3.82 6.82 4 6.6 4H5C3.9 4 3 4.9 3 6V20C3 21.1 3.9 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 19.6C19 19.82 18.82 20 18.6 20H5.4C5.18 20 5 19.82 5 19.6V10.4C5 10.18 5.18 10 5.4 10H18.6C18.82 10 19 10.18 19 10.4V19.6ZM19 7.6C19 7.82 18.82 8 18.6 8H5.4C5.18 8 5 7.82 5 7.6V6.4C5 6.18 5.18 6 5.4 6H18.6C18.82 6 19 6.18 19 6.4V7.6Z"
        fill="#262338"
      />
      <path
        d="M15.71 13.72L10.63 11.07C10.37 10.94 10.08 10.89 9.80005 10.93C9.51005 10.97 9.25005 11.11 9.05005 11.32C8.84005 11.52 8.71005 11.79 8.65005 12.08C8.60005 12.37 8.63005 12.66 8.74005 12.93L9.61005 15.03L8.74005 17.06C8.65005 17.28 8.61005 17.52 8.63005 17.75C8.65005 17.99 8.72005 18.22 8.85005 18.42C8.97005 18.62 9.15005 18.79 9.35005 18.9C9.55005 19.01 9.78005 19.07 10.02 19.07C10.23 19.07 10.45 19.02 10.65 18.92L15.72 16.27C15.95 16.15 16.14 15.97 16.28 15.74C16.41 15.51 16.48 15.26 16.48 14.99C16.48 14.72 16.41 14.47 16.28 14.24C16.15 14.01 15.95 13.83 15.72 13.71L15.71 13.72ZM15.11 15.07L9.98005 17.7L9.96005 17.61L10.78 15.68H12.47C12.65 15.68 12.82 15.61 12.94 15.48C13.06 15.36 13.13 15.18 13.13 15C13.13 14.82 13.06 14.65 12.94 14.52C12.82 14.39 12.64 14.32 12.47 14.32H10.78L9.95005 12.34L10.03 12.28L15.13 14.95V15.04C15.13 15.04 15.12 15.06 15.11 15.07V15.07Z"
        fill="#262338"
      />
    </g>
    <defs>
      <clipPath id="clip0_2754_9261">
        <rect width="18" height="20" fill="white" transform="translate(3 2)" />
      </clipPath>
    </defs>
  </svg>
);

/* People Icon */
export const PeopleIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      d="M12.3 12.22C12.8336 11.7581 13.2616 11.1869 13.5549 10.545C13.8482 9.90316 14 9.20571 14 8.5C14 7.17392 13.4732 5.90215 12.5355 4.96447C11.5979 4.02678 10.3261 3.5 9 3.5C7.67392 3.5 6.40215 4.02678 5.46447 4.96447C4.52678 5.90215 4 7.17392 4 8.5C3.99999 9.20571 4.1518 9.90316 4.44513 10.545C4.73845 11.1869 5.16642 11.7581 5.7 12.22C4.30014 12.8539 3.11247 13.8775 2.27898 15.1685C1.4455 16.4596 1.00147 17.9633 1 19.5C1 19.7652 1.10536 20.0196 1.29289 20.2071C1.48043 20.3946 1.73478 20.5 2 20.5C2.26522 20.5 2.51957 20.3946 2.70711 20.2071C2.89464 20.0196 3 19.7652 3 19.5C3 17.9087 3.63214 16.3826 4.75736 15.2574C5.88258 14.1321 7.4087 13.5 9 13.5C10.5913 13.5 12.1174 14.1321 13.2426 15.2574C14.3679 16.3826 15 17.9087 15 19.5C15 19.7652 15.1054 20.0196 15.2929 20.2071C15.4804 20.3946 15.7348 20.5 16 20.5C16.2652 20.5 16.5196 20.3946 16.7071 20.2071C16.8946 20.0196 17 19.7652 17 19.5C16.9985 17.9633 16.5545 16.4596 15.721 15.1685C14.8875 13.8775 13.6999 12.8539 12.3 12.22V12.22ZM9 11.5C8.40666 11.5 7.82664 11.3241 7.33329 10.9944C6.83994 10.6648 6.45542 10.1962 6.22836 9.64805C6.0013 9.09987 5.94189 8.49667 6.05764 7.91473C6.1734 7.33279 6.45912 6.79824 6.87868 6.37868C7.29824 5.95912 7.83279 5.6734 8.41473 5.55764C8.99667 5.44189 9.59987 5.5013 10.1481 5.72836C10.6962 5.95542 11.1648 6.33994 11.4944 6.83329C11.8241 7.32664 12 7.90666 12 8.5C12 9.29565 11.6839 10.0587 11.1213 10.6213C10.5587 11.1839 9.79565 11.5 9 11.5ZM18.74 11.82C19.38 11.0993 19.798 10.2091 19.9438 9.25634C20.0896 8.30362 19.9569 7.32907 19.5618 6.45C19.1666 5.57093 18.5258 4.8248 17.7165 4.30142C16.9071 3.77805 15.9638 3.49974 15 3.5C14.7348 3.5 14.4804 3.60536 14.2929 3.79289C14.1054 3.98043 14 4.23478 14 4.5C14 4.76522 14.1054 5.01957 14.2929 5.20711C14.4804 5.39464 14.7348 5.5 15 5.5C15.7956 5.5 16.5587 5.81607 17.1213 6.37868C17.6839 6.94129 18 7.70435 18 8.5C17.9986 9.02524 17.8593 9.5409 17.5961 9.99542C17.3328 10.4499 16.9549 10.8274 16.5 11.09C16.3517 11.1755 16.2279 11.2977 16.1404 11.4447C16.0528 11.5918 16.0045 11.7589 16 11.93C15.9958 12.0998 16.0349 12.2678 16.1137 12.4183C16.1924 12.5687 16.3081 12.6967 16.45 12.79L16.84 13.05L16.97 13.12C18.1754 13.6917 19.1923 14.596 19.901 15.7263C20.6096 16.8566 20.9805 18.1659 20.97 19.5C20.97 19.7652 21.0754 20.0196 21.2629 20.2071C21.4504 20.3946 21.7048 20.5 21.97 20.5C22.2352 20.5 22.4896 20.3946 22.6771 20.2071C22.8646 20.0196 22.97 19.7652 22.97 19.5C22.9782 17.9654 22.5938 16.4543 21.8535 15.1101C21.1131 13.7659 20.0413 12.6333 18.74 11.82V11.82Z"
      fill="#262338"
    />
  </svg>
);

/* Move Attendee Icon */
export const MoveAttendeeIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g clipPath="url(#clip0_3010_9102)">
      <path
        d="M13.3 12.22C13.8336 11.7581 14.2616 11.1869 14.5549 10.545C14.8482 9.90316 15 9.20571 15 8.5C15 7.17392 14.4732 5.90215 13.5355 4.96447C12.5979 4.02678 11.3261 3.5 10 3.5C8.67392 3.5 7.40215 4.02678 6.46447 4.96447C5.52678 5.90215 5 7.17392 5 8.5C4.99999 9.20571 5.1518 9.90316 5.44513 10.545C5.73845 11.1869 6.16642 11.7581 6.7 12.22C5.30014 12.8539 4.11247 13.8775 3.27898 15.1685C2.4455 16.4596 2.00147 17.9633 2 19.5C2 19.7652 2.10536 20.0196 2.29289 20.2071C2.48043 20.3946 2.73478 20.5 3 20.5C3.26522 20.5 3.51957 20.3946 3.70711 20.2071C3.89464 20.0196 4 19.7652 4 19.5C4 17.9087 4.63214 16.3826 5.75736 15.2574C6.88258 14.1321 8.4087 13.5 10 13.5C11.5913 13.5 13.1174 14.1321 14.2426 15.2574C15.3679 16.3826 16 17.9087 16 19.5C16 19.7652 16.1054 20.0196 16.2929 20.2071C16.4804 20.3946 16.7348 20.5 17 20.5C17.2652 20.5 17.5196 20.3946 17.7071 20.2071C17.8946 20.0196 18 19.7652 18 19.5C17.9985 17.9633 17.5545 16.4596 16.721 15.1685C15.8875 13.8775 14.6999 12.8539 13.3 12.22ZM10 11.5C9.40666 11.5 8.82664 11.3241 8.33329 10.9944C7.83994 10.6648 7.45542 10.1962 7.22836 9.64805C7.0013 9.09987 6.94189 8.49667 7.05764 7.91473C7.1734 7.33279 7.45912 6.79824 7.87868 6.37868C8.29824 5.95912 8.83279 5.6734 9.41473 5.55764C9.99667 5.44189 10.5999 5.5013 11.1481 5.72836C11.6962 5.95542 12.1648 6.33994 12.4944 6.83329C12.8241 7.32664 13 7.90666 13 8.5C13 9.29565 12.6839 10.0587 12.1213 10.6213C11.5587 11.1839 10.7956 11.5 10 11.5Z"
        fill="#262338"
      />
      <path
        d="M21.7861 11.5312C21.8544 11.46 21.908 11.376 21.9437 11.284C22.0188 11.1016 22.0188 10.8971 21.9437 10.7147C21.908 10.6228 21.8544 10.5388 21.7861 10.4675L19.5347 8.2203C19.3934 8.07924 19.2017 8 19.0019 8C18.802 8 18.6104 8.07924 18.469 8.2203C18.3277 8.36135 18.2483 8.55266 18.2483 8.75214C18.2483 8.95162 18.3277 9.14293 18.469 9.28398L19.4446 10.2503H16.7505C16.5514 10.2503 16.3605 10.3292 16.2198 10.4697C16.0791 10.6102 16 10.8007 16 10.9994C16 11.198 16.0791 11.3886 16.2198 11.529C16.3605 11.6695 16.5514 11.7484 16.7505 11.7484H19.4446L18.469 12.7147C18.3987 12.7844 18.3429 12.8672 18.3048 12.9585C18.2667 13.0498 18.2471 13.1477 18.2471 13.2466C18.2471 13.3455 18.2667 13.4434 18.3048 13.5347C18.3429 13.6259 18.3987 13.7088 18.469 13.7784C18.5388 13.8486 18.6218 13.9044 18.7133 13.9424C18.8047 13.9804 18.9028 14 19.0019 14C19.1009 14 19.199 13.9804 19.2905 13.9424C19.3819 13.9044 19.4649 13.8486 19.5347 13.7784L21.7861 11.5312Z"
        fill="#262338"
      />
    </g>
    <defs>
      <clipPath id="clip0_3010_9102">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

/* Copy Icon */
export const CopyIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      d="M8 8V5.2C8 4.0799 8 3.51984 8.21799 3.09202C8.40973 2.71569 8.71569 2.40973 9.09202 2.21799C9.51984 2 10.0799 2 11.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.0799 22 5.2V12.8C22 13.9201 22 14.4802 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.4802 16 19.9201 16 18.8 16H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z"
      stroke="#262338"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/* Capacity Icon */
export const CapacityIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g clipPath="url(#clip0_2753_9233)">
      <path
        d="M11.9995 2C6.4857 2 2 6.4857 2 11.9995C2 12.0791 2.0009 12.1587 2.0027 12.2374L2 12.2429L2.0027 12.2493C2.1363 17.6478 6.5689 21.999 11.9995 21.999C17.4301 21.999 21.999 17.5134 21.999 11.9995C21.999 6.4857 17.5143 2 11.9995 2ZM20.3426 12.2438C20.3426 14.6174 19.3803 16.7669 17.8244 18.3229L11.7462 12.2438H11.7352V3.65104C11.823 3.6483 11.9117 3.6465 11.9995 3.6465C16.606 3.6465 20.3526 7.394 20.3526 11.9995C20.3526 12.0809 20.3508 12.1624 20.349 12.2438H20.3426V12.2438Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2753_9233">
        <rect width="22" height="22" fill="white" transform="translate(1 1)" />
      </clipPath>
    </defs>
  </svg>
);

/* Checkmark Icon */
export const CheckmarkIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      d="M19.227 5.16 9.192 14.81l-3.86-3.704a2.3 2.3 0 0 0-.758-.56 2.42 2.42 0 0 0-2.672.433 2.2 2.2 0 0 0-.524.769 2.16 2.16 0 0 0 .072 1.796c.14.278.34.526.584.727l5.497 5.298c.219.208.478.372.763.484a2.43 2.43 0 0 0 2.535-.484L22.525 8.346c.219-.208.393-.456.512-.73a2.17 2.17 0 0 0 0-1.726 2.2 2.2 0 0 0-.512-.73 2.4 2.4 0 0 0-1.65-.654 2.4 2.4 0 0 0-1.648.653"
      fill="currentColor"
    />
  </svg>
);

/* Clipboard Icon */
export const ClipboardIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      d="M13 14H9C8.73478 14 8.48043 14.1054 8.29289 14.2929C8.10536 14.4804 8 14.7348 8 15C8 15.2652 8.10536 15.5196 8.29289 15.7071C8.48043 15.8946 8.73478 16 9 16H13C13.2652 16 13.5196 15.8946 13.7071 15.7071C13.8946 15.5196 14 15.2652 14 15C14 14.7348 13.8946 14.4804 13.7071 14.2929C13.5196 14.1054 13.2652 14 13 14ZM17 4H15.82C15.6137 3.41645 15.2319 2.911 14.7271 2.55294C14.2222 2.19488 13.6189 2.00174 13 2H11C10.3811 2.00174 9.7778 2.19488 9.27293 2.55294C8.76807 2.911 8.38631 3.41645 8.18 4H7C6.20435 4 5.44129 4.31607 4.87868 4.87868C4.31607 5.44129 4 6.20435 4 7V19C4 19.7956 4.31607 20.5587 4.87868 21.1213C5.44129 21.6839 6.20435 22 7 22H17C17.7956 22 18.5587 21.6839 19.1213 21.1213C19.6839 20.5587 20 19.7956 20 19V7C20 6.20435 19.6839 5.44129 19.1213 4.87868C18.5587 4.31607 17.7956 4 17 4V4ZM10 5C10 4.73478 10.1054 4.48043 10.2929 4.29289C10.4804 4.10536 10.7348 4 11 4H13C13.2652 4 13.5196 4.10536 13.7071 4.29289C13.8946 4.48043 14 4.73478 14 5V6H10V5ZM18 19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H7C6.73478 20 6.48043 19.8946 6.29289 19.7071C6.10536 19.5196 6 19.2652 6 19V7C6 6.73478 6.10536 6.48043 6.29289 6.29289C6.48043 6.10536 6.73478 6 7 6H8V7C8 7.26522 8.10536 7.51957 8.29289 7.70711C8.48043 7.89464 8.73478 8 9 8H15C15.2652 8 15.5196 7.89464 15.7071 7.70711C15.8946 7.51957 16 7.26522 16 7V6H17C17.2652 6 17.5196 6.10536 17.7071 6.29289C17.8946 6.48043 18 6.73478 18 7V19ZM15 10H9C8.73478 10 8.48043 10.1054 8.29289 10.2929C8.10536 10.4804 8 10.7348 8 11C8 11.2652 8.10536 11.5196 8.29289 11.7071C8.48043 11.8946 8.73478 12 9 12H15C15.2652 12 15.5196 11.8946 15.7071 11.7071C15.8946 11.5196 16 11.2652 16 11C16 10.7348 15.8946 10.4804 15.7071 10.2929C15.5196 10.1054 15.2652 10 15 10Z"
      fill="currentColor"
    />
  </svg>
);

/* HalfFull Icon */
export const HalfFullIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <circle cx="12.1168" cy="11.9289" r="9.1918" fill="white" />
    <path
      d="M20.8299 7.32002C20.0189 5.80447 18.8351 4.52071 17.3899 3.59001V3.59001C16.0822 2.74869 14.5962 2.22396 13.0501 2.05749C11.504 1.89103 9.94037 2.0874 8.48351 2.63109C7.02665 3.17478 5.71656 4.05069 4.65748 5.18931C3.59839 6.32793 2.81943 7.69785 2.38249 9.19019C1.94556 10.6825 1.86269 12.2564 2.14049 13.7864C2.41829 15.3164 3.04905 16.7606 3.98267 17.9998C4.91629 19.2391 6.1271 20.2563 7.5188 20.9499C8.91051 21.6436 10.4449 22.0032 11.9999 22.0001L12.29 22.0001C13.9891 21.9499 15.647 21.4675 17.1081 20.5983C18.5692 19.7291 19.7839 18.5026 20.6387 17.0328C21.4935 15.5631 21.9596 13.9006 21.9931 12.2012C22.0265 10.5017 21.6262 8.8218 20.8299 7.32002V7.32002ZM11.0001 19.93C9.07812 19.6741 7.31458 18.7289 6.03731 17.2703C4.76004 15.8117 4.05593 13.9389 4.05593 12C4.05593 10.0612 4.76004 8.1883 6.03731 6.72972C7.31458 5.27114 9.07812 4.32594 11.0001 4.07001L11.0001 19.93ZM13.0001 4.07001C13.865 4.1806 14.7054 4.43051 15.4899 4.81002L13.0001 9.12001L13.0001 4.07001ZM13.0001 13.07L17.1701 5.9C17.7848 6.42796 18.3174 7.04478 18.7501 7.73001L13.0001 17.69L13.0001 13.07ZM14.1501 19.65L19.7401 10C19.9092 10.6534 20.0001 11.3252 20.0001 12C19.9987 13.7461 19.4263 15.4437 18.3701 16.8339C17.3138 18.2242 15.8316 19.2307 14.1501 19.7001L14.1501 19.65Z"
      fill="currentColor"
    />
  </svg>
);

/* ChatBubble Icon */
export const ChatBubbleIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      d="M12.0001 2C10.6869 2 9.38653 2.25866 8.17328 2.7612C6.96002 3.26375 5.85763 4.00035 4.92904 4.92893C3.05368 6.8043 2.00011 9.34784 2.00011 12C1.99137 14.3091 2.7909 16.5485 4.26011 18.33L2.26011 20.33C2.12135 20.4706 2.02736 20.6492 1.98998 20.8432C1.95261 21.0372 1.97353 21.2379 2.05011 21.42C2.13317 21.5999 2.26781 21.7511 2.43696 21.8544C2.6061 21.9577 2.80211 22.0083 3.00011 22H12.0001C14.6523 22 17.1958 20.9464 19.0712 19.0711C20.9465 17.1957 22.0001 14.6522 22.0001 12C22.0001 9.34784 20.9465 6.8043 19.0712 4.92893C17.1958 3.05357 14.6523 2 12.0001 2ZM12.0001 20H5.41011L6.34011 19.07C6.52636 18.8826 6.6309 18.6292 6.6309 18.365C6.6309 18.1008 6.52636 17.8474 6.34011 17.66C5.0307 16.352 4.21528 14.6305 4.0328 12.7888C3.85032 10.947 4.31205 9.09901 5.33934 7.55952C6.36662 6.02004 7.8959 4.88436 9.66663 4.34597C11.4374 3.80759 13.34 3.8998 15.0503 4.60691C16.7607 5.31402 18.173 6.59227 19.0465 8.22389C19.9201 9.85551 20.201 11.7395 19.8412 13.555C19.4815 15.3705 18.5034 17.005 17.0736 18.1802C15.6439 19.3554 13.8509 19.9985 12.0001 20Z"
      fill="currentColor"
    />
  </svg>
);

/* Focus Mode Icon */
export const FocusModeIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.033 9.01a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0 4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3.002 6.751V3.004h3.76"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={2}
      d="m3.785 3.7 3.467 3.466"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21.005 6.735V2.988h-3.76"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={2}
      d="M20.222 3.683 16.754 7.15"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.992 17.237v3.748h-3.76"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={2}
      d="m20.21 20.29-3.468-3.468"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3.025 17.203v3.747h3.76"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={2}
      d="m3.808 20.255 3.467-3.467"
    />
  </svg>
);

/* Appointment Status Icons */
/* Pending Icon */
export const PendingIconSmall: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      d="M12 22c-5.52-.006-9.994-4.48-10-10v-.2C2.11 6.305 6.635 1.928 12.13 2c5.497.074 9.904 4.569 9.868 10.065C21.962 17.562 17.497 22 12 22"
      fill="currentColor"
    />
    <circle cx={6.882} cy={11.957} r={1.957} fill="#fff" />
    <circle cx={11.977} cy={11.957} r={1.957} fill="#fff" />
    <circle cx={17.073} cy={11.957} r={1.957} fill="#fff" />
  </svg>
);

/* In Progress Icon */
export const InProgressIconSmall: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path fill="#fff" d="M7.5 7.5H16V16H7.5z" />
    <path
      fill="currentColor"
      d="M12 22c-5.52-.006-9.994-4.48-10-10v-.2C2.11 6.305 6.635 1.928 12.13 2c5.497.074 9.904 4.569 9.868 10.065C21.962 17.562 17.497 22 12 22M10.8 8.1a.5.5 0 0 0-.8.4v7a.5.5 0 0 0 .8.4l4.347-3.26a.8.8 0 0 0 0-1.28z"
    />
  </svg>
);

/* Complete Icon */
export const CompleteIconSmall: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <circle cx={11.987} cy={12.002} r={10} fill="currentColor" />
    <path
      fill="#fff"
      d="M15.705 8.182 10.383 13.3l-2.046-1.964a1.2 1.2 0 0 0-.402-.297 1.28 1.28 0 0 0-1.418.23q-.182.176-.277.407a1.15 1.15 0 0 0 .038.953q.113.224.31.386l2.915 2.809q.176.166.404.257a1.29 1.29 0 0 0 1.345-.257l6.202-5.952c.116-.11.208-.242.271-.387a1.15 1.15 0 0 0-.271-1.303 1.27 1.27 0 0 0-.875-.346c-.327 0-.642.124-.874.346"
    />
  </svg>
);

/* Declined Icon */
export const DeclinedIconSmall: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <circle cx={12.707} cy={12.505} r={10} fill="currentColor" />
    <path
      fill="#fff"
      d="M12.708 16.255a1.25 1.25 0 1 0 0 2.498 1.25 1.25 0 0 0 0-2.498m0-10a1.25 1.25 0 0 0-1.25 1.25v5a1.25 1.25 0 1 0 2.5 0v-5a1.25 1.25 0 0 0-1.25-1.25"
    />
  </svg>
);

/* Payment Icon */
export const PaymentIconSmall: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <circle cx={11.987} cy={12.505} r={10} fill="currentColor" />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.931 9.75s-.367-1.779-2.936-1.779-3.25 1.079-3.302 1.821c-.053.743-.053 2.42 3.302 2.42s3.356 1.958 3.356 2.237-.053 2.415-3.356 2.415-3.302-1.778-3.302-1.778M11.995 6.341v12.302"
    />
  </svg>
);

/* Refund Icon */
export const RefundIconSmall: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <circle cx={11.987} cy={12.646} r={10} fill="currentColor" />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.931 9.892s-.367-1.779-2.936-1.779-3.25 1.078-3.302 1.821-.053 2.42 3.302 2.42 3.356 1.957 3.356 2.237-.053 2.415-3.356 2.415-3.302-1.779-3.302-1.779M11.995 6.483v12.302"
    />
  </svg>
);

export const ReviewIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={cn('w-6 h-6', props.className)}
  >
    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"></path>
    <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"></path>
    <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"></path>
    <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"></path>
  </svg>
);

export const ManualReviewIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={cn('w-6 h-6', props.className)}
  >
    <path
      fill="currentColor"
      d="M15.213 10.302a4.794 4.794 0 0 1-4.8-4.79 4.794 4.794 0 0 1 4.8-4.789 4.794 4.794 0 0 1 4.799 4.79 4.8 4.8 0 0 1-4.8 4.789m0-8.21a3.424 3.424 0 0 0-3.428 3.42c0 1.89 1.534 3.421 3.428 3.421a3.424 3.424 0 0 0 3.427-3.42c0-1.89-1.534-3.421-3.427-3.421M4.495 9.978a4.477 4.477 0 0 0 4.482-4.472 4.477 4.477 0 0 0-4.482-4.472 4.477 4.477 0 0 0-4.48 4.472 4.477 4.477 0 0 0 4.48 4.472M4.495 20.712a4.48 4.48 0 0 0 4.484-4.474 4.48 4.48 0 0 0-4.484-4.475 4.48 4.48 0 0 0-4.484 4.475 4.48 4.48 0 0 0 4.484 4.474M15.249 20.723a4.49 4.49 0 0 0 4.495-4.485 4.49 4.49 0 0 0-4.495-4.486 4.49 4.49 0 0 0-4.495 4.486 4.49 4.49 0 0 0 4.495 4.485"
    />
  </svg>
);

export const TopRightArrowIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={cn('w-6 h-6', props.className)}
  >
    <g clipPath="url(#a)">
      <path
        fill="#262338"
        d="M17.565 5.668a1.4 1.4 0 0 0-.543-.12H6.976a1.427 1.427 0 1 0 0 2.853l6.62-.01-7.625 7.625a1.421 1.421 0 0 0 2.01 2.01l7.625-7.626-.01 6.62a1.42 1.42 0 0 0 1.426 1.427 1.42 1.42 0 0 0 1.427-1.426V6.974a1.4 1.4 0 0 0-.12-.542 1.42 1.42 0 0 0-.764-.764"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const NotificationsIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className={cn('w-6 h-6', props.className)}
  >
    <path
      stroke="#262338"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 19a3 3 0 1 1-6 0m4.796-12.761a2.5 2.5 0 1 0-3.593 0M18 11.2c0-1.38-.632-2.702-1.758-3.677S13.592 6 12 6c-1.59 0-3.118.548-4.243 1.523S6 9.821 6 11.2c0 2.282-.566 3.95-1.272 5.145-.805 1.36-1.207 2.041-1.19 2.204.017.186.05.244.201.355.132.096.794.096 2.12.096h12.283c1.324 0 1.987 0 2.118-.096.151-.11.185-.17.203-.355.016-.163-.387-.843-1.19-2.204C18.565 15.15 18 13.482 18 11.2"
    />
  </svg>
);

/* Email Notification Icon */
export const EmailNotificationIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 37 37"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g clipPath="url(#a)">
      <mask
        id="b"
        width={36}
        height={36}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M35.584.765H.557v35.027h35.027z" />
      </mask>
      <g mask="url(#b)">
        <path
          fill="#EEF9FF"
          d="M18.07 35.792c9.673 0 17.514-7.841 17.514-17.514S27.743.765 18.07.765.557 8.605.557 18.278s7.84 17.514 17.513 17.514"
        />
        <path fill="#fff" d="m26.325 11.799-16.977.052v13.634l17.278.156z" />
        <path
          fill="#2563EB"
          d="M25.095 10.71h-14.19a3.04 3.04 0 0 0-3.04 3.039v10.13a3.04 3.04 0 0 0 3.04 3.04h14.19a3.04 3.04 0 0 0 3.04-3.04V13.75a3.04 3.04 0 0 0-3.04-3.04m-.416 2.026-5.96 5.957a1.02 1.02 0 0 1-1.109.221 1 1 0 0 1-.33-.221l-5.96-5.957zm1.429 11.144a1.013 1.013 0 0 1-1.014 1.013H10.906a1.014 1.014 0 0 1-1.013-1.013v-9.716l5.96 5.957a3.04 3.04 0 0 0 4.297 0l5.959-5.957z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h36v36H0z" />
      </clipPath>
    </defs>
  </svg>
);

/* SMS Notification Icon */
export const SMSlNotificationIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 37 37"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g clipPath="url(#a)">
      <mask
        id="b"
        width={36}
        height={36}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M35.584.869H.557v35.027h35.027z" />
      </mask>
      <g mask="url(#b)">
        <path
          fill="#EEF9FF"
          d="M18.07 35.896c9.673 0 17.514-7.841 17.514-17.513S27.743.869 18.07.869.557 8.71.557 18.383s7.84 17.513 17.513 17.513"
        />
        <path
          fill="#fff"
          d="m11.397 24.798-1.71 2.06 3.692.505 6.063-.233 3.575-1.71 3.42-4.509-.544-5.44-2.332-3.576-3.653-2.06-6.063.622-4.547 4.08-.466 5.558z"
        />
        <path
          fill="#2563EB"
          d="M13.892 17.02a1.017 1.017 0 1 0 0 2.034 1.017 1.017 0 0 0 0-2.034m4.072 0a1.018 1.018 0 1 0 0 2.035 1.018 1.018 0 0 0 0-2.035m4.071 0a1.017 1.017 0 1 0 0 2.035 1.017 1.017 0 0 0 0-2.035m-4.071-9.16A10.18 10.18 0 0 0 7.785 18.037c-.009 2.35.805 4.63 2.3 6.443L8.05 26.516a1.02 1.02 0 0 0-.214 1.11 1.02 1.02 0 0 0 .967.59h9.16a10.179 10.179 0 0 0 0-20.357m0 18.32h-6.708l.947-.946a1.02 1.02 0 0 0 0-1.435 8.143 8.143 0 1 1 5.76 2.381"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h36v36H0z" />
      </clipPath>
    </defs>
  </svg>
);

/* Multiple Notification Icon */
export const MultipleNotificationIcon: FC<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#EEF9FF"
        d="M12.045 24.353c6.723 0 12.173-5.45 12.173-12.173S18.768.008 12.045.008-.127 5.457-.127 12.18s5.45 12.173 12.172 12.173"
      />
      <path
        fill="#fff"
        d="M10.528 5.984a5.107 5.107 0 0 1 5.085 4.647 3.92 3.92 0 1 1-4.385 5.519 5.108 5.108 0 1 1-.7-10.166"
      />
      <path
        fill="#2563EB"
        d="M18.034 17.181a4.867 4.867 0 0 0-1.904-7.346 5.561 5.561 0 1 0-9.863 4.371l-.966.96a.7.7 0 0 0-.146.757.695.695 0 0 0 .64.431h3.954a4.87 4.87 0 0 0 4.386 2.78h4.17a.7.7 0 0 0 .64-.43.695.695 0 0 0-.146-.758zM9.27 14.27q.001.35.055.695H7.47l.243-.236a.695.695 0 0 0 0-.987 4.12 4.12 0 0 1-1.223-2.947 4.17 4.17 0 0 1 4.17-4.17 4.13 4.13 0 0 1 3.927 2.78h-.452a4.865 4.865 0 0 0-4.865 4.865m7.326 3.475.034.035h-2.495a3.476 3.476 0 1 1 2.46-1.015.7.7 0 0 0-.208.487.7.7 0 0 0 .209.493"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

/* Notifications Disabled Icon */
export const NotificationsDisabledIcon: FC<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <mask
        id="b"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M0 0h23.351v23.351H0z" />
      </mask>
      <g mask="url(#b)">
        <mask
          id="c"
          width={24}
          height={24}
          x={0}
          y={0}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: 'luminance',
          }}
        >
          <path fill="#fff" d="M23.082.49H.361v22.72h22.72z" />
        </mask>
        <g mask="url(#c)">
          <path
            fill="#F1F5F9"
            d="M11.721 23.21c6.275 0 11.36-5.086 11.36-11.36 0-6.275-5.085-11.36-11.36-11.36S.361 5.576.361 11.85s5.086 11.36 11.36 11.36"
          />
          <path
            fill="#fff"
            d="m7.422 13.525-1.163 2.91 1.605.408 1.622.175.325.948 1.473 1.105 1.85-.33.499-1.724 2.222-.149-.1-1.3.2-3.37-.4-2.673-1.948-1.298-.225-1.124-.574-1.948-1.323-.125-1.174.725.05 2.04-1.775 1.28-.407 1.047z"
          />
          <path
            fill="#fff"
            d="M13.87 16.854c0 1.165-.907 2.11-2.027 2.11s-2.028-.945-2.028-2.11M8.719 9.04a3.44 3.44 0 0 0-.932 2.331c0 1.604-.382 2.777-.86 3.616-.543.958-.816 1.436-.805 1.55.013.13.035.172.136.25.09.067.538.067 1.433.067h9.478m-5.326-9.139q-.297 0-.588.04c-.258.033-.387.05-.516.013a.84.84 0 0 1-.302-.182.65.65 0 0 1-.157-.255 1.8 1.8 0 0 1-.127-.67c0-.97.757-1.758 1.69-1.758.934 0 1.69.787 1.69 1.758 0 .475-.182.906-.476 1.222a4.5 4.5 0 0 0-1.214-.168m0 0c1.076 0 2.107.386 2.868 1.07.76.687 1.187 1.616 1.187 2.586q0 .352.018.678m2.01 5.508L5.759 6.31Z"
          />
          <path
            stroke="#262338"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.297}
            d="M13.87 16.854c0 1.165-.907 2.11-2.027 2.11s-2.028-.945-2.028-2.11M8.719 9.04a3.44 3.44 0 0 0-.932 2.331c0 1.604-.382 2.777-.86 3.616-.543.958-.816 1.436-.805 1.55.013.13.035.172.136.25.09.067.538.067 1.433.067h9.478m-5.326-9.139q-.297 0-.588.04c-.258.033-.387.05-.516.013a.84.84 0 0 1-.302-.182.65.65 0 0 1-.157-.255 1.8 1.8 0 0 1-.127-.67c0-.97.757-1.758 1.69-1.758.934 0 1.69.787 1.69 1.758 0 .475-.182.906-.476 1.222a4.5 4.5 0 0 0-1.214-.168m0 0c1.076 0 2.107.386 2.868 1.07.76.687 1.187 1.616 1.187 2.586q0 .352.018.678m2.01 5.508L5.759 6.31"
          />
        </g>
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

/* Business Store Icon */
export const BusinessStoreIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 37 37"
    width={24}
    height={24}
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <mask
      id="a"
      width={22}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path fill="#fff" d="M22 0H0v20h22z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#262338"
        fillRule="evenodd"
        d="M3.743 0c-.55 0-1.078.221-1.462.621s-.612.926-.612 1.484v1.937L.105 8.811a2.1 2.1 0 0 0-.093.884c.03.294.124.59.27.842.144.263.352.484.59.652.239.169.508.295.799.348v6.358c0 .558.217 1.095.611 1.484.394.4.912.621 1.462.621h14.515c.55 0 1.078-.221 1.461-.621.384-.4.612-.926.612-1.484v-6.358c.29-.063.56-.18.798-.348.239-.168.436-.4.591-.652.146-.263.239-.548.27-.842.031-.295 0-.6-.093-.884L20.33 4.042V2.105c0-.558-.218-1.094-.612-1.484A2.04 2.04 0 0 0 18.258 0zm10.368 17.895h4.147v-6.316H3.743v6.316H7.89v-3.158c0-.842.332-1.642.912-2.232A3.1 3.1 0 0 1 11 11.58c.82 0 1.618.337 2.198.926.58.59.913 1.4.913 2.232zm-4.147 0h2.073v-3.158c0-.284-.114-.547-.3-.748a1.02 1.02 0 0 0-.737-.305 1.032 1.032 0 0 0-1.037 1.053zm-7.89-8.421 1.379-4.21h1.659l-.695 4.21zm4.448 0 .694-4.21h2.748v4.21zm5.515 0v-4.21h2.747l.695 4.21zm5.547 0-.695-4.21h1.659l1.379 4.21h-2.354zm.674-7.369v1.053H3.743V2.105z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M9.964 9.474v-4.21H7.216l-.695 4.21zM5.111 5.263H3.453l-1.38 4.21h2.354zM12.037 9.474h3.442l-.684-4.21h-2.758z"
        clipRule="evenodd"
      />
      <path fill="#fff" d="M18.258 2.105H3.743v1.053h14.515z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M11 13.684a1.033 1.033 0 0 0-1.037 1.053v3.158h2.074v-3.158c0-.284-.114-.547-.3-.748a1.02 1.02 0 0 0-.737-.305M16.889 5.263l.694 4.21h2.354l-1.39-4.21zM13.198 12.505c.581.59.913 1.4.913 2.232v3.158h4.147v-6.316H11c.829 0 1.617.337 2.197.926M3.743 17.895H7.89v-3.158c0-.842.332-1.642.913-2.232A3.1 3.1 0 0 1 11 11.58H3.743z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

/* Package Icon */
export const PackageIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="currentColor"
        d="M21.997 6.874c-.07-.469-.465-.644-.728-.76-2.33-1.035-4.696-2.094-6.984-3.119l-1.767-.79q-.09-.041-.179-.084l-.15-.07h-.001a.46.46 0 0 0-.421 0h-.002l-.943.426q-.986.445-1.972.888l-.877.392C6.226 4.54 4.42 5.35 2.637 6.136c-.435.193-.638.49-.637.935.006 3.189.007 6.527 0 9.923 0 .443.196.737.62.925 2.7 1.199 5.609 2.499 8.891 3.973q.24.108.471.108.234 0 .48-.11c2.83-1.271 5.74-2.571 8.892-3.975.223-.099.532-.275.637-.652l.009-.032V6.91zM9.721 4.66c.777-.348 1.511-.676 2.26-1.006 2.313 1.03 4.675 2.086 6.959 3.107l.314.14-.05.023c-.715.321-1.455.653-2.184.972a.2.2 0 0 1-.043.006c-2.348-1.044-4.732-2.11-7.038-3.141l-.221-.1zm1.439 13.99v1.394l-1.603-.717q-2.945-1.318-5.891-2.632l-.02-.01v-.002c.004-2.449.004-4.94.004-7.348V8.117l1.479.661c1.958.876 3.984 1.782 5.978 2.668q.055.027.053.028c.001.004.006.02.006.06-.005 2.372-.005 4.785-.005 7.117zm.844-8.512a.1.1 0 0 1-.042.003C9.59 9.088 7.182 8.01 4.852 6.968l-.147-.066.156-.07c1.02-.456 1.983-.888 2.967-1.32a.3.3 0 0 1 .064.02c1.622.722 3.27 1.46 4.864 2.173l1.016.455 1.22.544.115.052-.103.047c-.984.44-2 .895-3 1.336m8.331 6.532a.3.3 0 0 1-.045.024c-2.04.909-4.113 1.836-6.117 2.733l-1.37.614V18.73c0-2.365 0-4.81-.003-7.215q0-.034.003-.044.007-.006.032-.017c.832-.365 1.674-.743 2.487-1.107l.7-.314v1.958c0 .328.187.582.524.714.286.112.59.06.84-.141.283-.232.283-.558.282-.665v-.992c0-.515 0-1.047-.005-1.57q0-.035.003-.046l.029-.014c.696-.305 1.401-.62 2.083-.926l.556-.248v1.36c0 2.346 0 4.771.004 7.157a.3.3 0 0 1-.003.05"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);

/* In Person Payment Icon */
export const InPersonPaymentIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path fill="#fff" d="M20.1 6.2H3.9v12h16.2z" />
    <path
      fill="#5D5FEF"
      d="M18.3 2.5c-1.2-.4-2.5-.4-3.7 0s-2.3 1.2-2.9 2.2c-.2.3-.2.6 0 .8.2.3.4.4.7.4s.5-.1.7-.4c.4-.7 1.1-1.2 1.9-1.5.8-.3 1.7-.3 2.5 0 .7.3 1.8 1.4 1.9 1.5.2.3.4.3.7.3.2 0 .3 0 .4-.1s.3-.2.3-.5c.1-.2 0-.4-.1-.6-.6-.9-1.5-1.8-2.6-2.1"
    />
    <path
      fill="#5D5FEF"
      d="M16.5 5.1c-1.1 0-2 .4-2.7 1.3-.2.2-.2.3-.2.6 0 .2.1.4.3.5s.3.2.5.2h.1c.2 0 .4-.1.5-.3.3-.4.9-.7 1.5-.7s1.1.3 1.5.7c.1.2.3.3.5.3.2 0 .4-.1.6-.2.2-.2.3-.3.3-.5 0-.2-.1-.4-.2-.6-.7-.9-1.6-1.3-2.7-1.3M11.6 14.5H6.4c-.2 0-.3.1-.3.3v1c0 .2.1.3.3.3h5.2c.2 0 .3-.1.3-.3v-1c0-.2-.1-.3-.3-.3"
    />
    <path
      fill="#5D5FEF"
      d="M18.6 8.5H4.4c-.2 0-.3-.1-.3-.3V7.4c0-.2.1-.3.3-.3h5.1c.2 0 .3-.1.3-.3V5.6c0-.2-.1-.3-.3-.3H4c-1 0-1.8.8-1.8 1.8v10.8c0 1 .8 1.8 1.8 1.8h14.4c1 0 1.8-.8 1.8-1.8V8.8c0-.2-.1-.3-.3-.3zm.3 8.6c0 .2-.1.3-.3.3H4.4c-.2 0-.3-.1-.3-.3v-4.7c0-.2.1-.3.3-.3h13.7c.2 0 .3.1.3.3z"
    />
  </svg>
);

/* Cancel Reader Action Icon */
export const CancelReaderActionIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="#FD0000"
      d="M19.54 2.533h.115c.23 0 .46.222.46.444v1.33c0 .222-.23.444-.46.444H9.793L15.3 8.953h4.356c.23 0 .46.222.46.444v3.864l2.184 1.657V2.533c0-1.109-.92-1.984-2.07-1.984H4.277l2.759 1.984zM22.678 16.284 1.713.292 1.667.257A.99.99 0 0 0 .253.339a1.027 1.027 0 0 0 .08 1.436l1.3.968v12.152c0 1.11.919 1.985 2.068 1.985H20.22l1.126.817.046.035a.956.956 0 0 0 1.368-.082.99.99 0 0 0-.08-1.39zM3.931 14.907c-.23 0-.46-.222-.46-.444V9.047c0-.222.23-.444.46-.444h5.161l2.759 2.101H5.655c-.23 0-.46.222-.46.444v1.214c0 .222.23.444.46.444h8.494l2.76 2.1z"
    />
  </svg>
);

/* Silent Notification Icon */
export const SilentNotificationIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    className={cn('w-6 h-6', props.className)}
    {...props}
  >
    <path
      fill="currentColor"
      d="M3.659 4.227a.846.846 0 0 1 1.127-.103l.066.056 3.792 3.506a1 1 0 0 1 .121.112l10.899 10.074a1 1 0 0 1 .09.084l.944.872.06.062a.845.845 0 0 1-1.14 1.235l-.066-.056-.749-.691H15.59c-.366 1.558-1.721 2.747-3.387 2.747s-3.021-1.189-3.387-2.747h-2.02c-.575 0-1.032 0-1.357-.012a5 5 0 0 1-.448-.033 2 2 0 0 1-.228-.047 1 1 0 0 1-.243-.101l-.1-.067a1.3 1.3 0 0 1-.363-.403 1.2 1.2 0 0 1-.134-.42L3.91 18.2c-.016-.18.025-.33.042-.391.024-.08.053-.157.081-.223.057-.132.136-.288.226-.458.183-.344.456-.825.807-1.442l.102-.185c.5-.951.907-2.281.907-4.108 0-1.053.324-2.068.91-2.94l-3.28-3.03-.06-.063a.845.845 0 0 1 .014-1.132m6.934 15.15c.299.637.92 1.059 1.609 1.059.688 0 1.31-.422 1.609-1.058zM13.558 5.26c0-.83-.638-1.445-1.356-1.445s-1.356.616-1.356 1.445q0 .226.06.429l.046.13v.002l.017.04.002.007q.003 0 .004.003l.017.01.002.002h.002l.12-.011.21-.027.217-.024q.218-.022.438-.03l.221-.003.232.004.031.001.123.007a7 7 0 0 1 .4.035l.126.015a7 7 0 0 1 .302.049 1.5 1.5 0 0 0 .142-.64m-5.793 6.133c0 2.09-.47 3.692-1.102 4.893l-.128.235c-.277.487-.493.87-.655 1.164.244.003.546.004.915.004h10.181l-8.729-8.07a3.55 3.55 0 0 0-.482 1.774m7.483-6.133c0 .409-.078.8-.218 1.16a6.1 6.1 0 0 1 1.473.98l.21.2c1.028 1.022 1.616 2.371 1.616 3.793q0 .438.021.84a.845.845 0 0 1-1.687.09 18 18 0 0 1-.023-.93c0-.945-.39-1.873-1.118-2.597l-.15-.142a4.6 4.6 0 0 0-2.119-1.065 5 5 0 0 0-1.38-.101l-.326.032c-.272.036-.64.1-1.013-.005a1.913 1.913 0 0 1-.685-.381l-.088-.086a1.7 1.7 0 0 1-.25-.326c-.065-.112-.107-.222-.13-.279l-.05-.139a3.2 3.2 0 0 1-.175-1.044c0-1.7 1.333-3.134 3.046-3.134s3.046 1.435 3.046 3.134"
    />
  </svg>
);
